<template>
  <div>
    <Breadcrumb :items="items" />
    <pre></pre>
    <div class="">
      <div class="chat_app mx-1 row" @click="uplodesActive = false">
        <div
          @click="toggleMenu"
          class="overlay"
          :class="{ active: menuActive }"
        ></div>
        <div class="friends_col col-md-4 col-xl-3 col-12">
          <div class="friends" :class="{ active: menuActive }">
            <span @click="toggleMenu" class="closeMenu"
              ><i class="far fa-times"></i
            ></span>
            <header class="friends_header">
              <!-- <v-autocomplete
                ref="autocomplete"
                :items="users"
                clearable
                :search-input.sync="autocomplete_text"
                @input="getUsers($event)"
                :item-text="nameWithCode"
                item-value="id"
                label="ابحث أو ابدأ محادثة جديدة"
              ></v-autocomplete> -->
              <div class="search-input-wrapper">
                <input
                  :type="searchType === 'name' ? 'text' : 'number'"
                  @input="getChats($event)"
                  v-model="autocomplete_text"
                  :placeholder="
                    searchType === 'name'
                      ? 'ابحث بالاسم هنا...'
                      : 'ابحث برقم الطلب هنا...'
                  "
                />
                <div class="search-type-selector">
                  <button
                    type="button"
                    class="search-type-btn"
                    :class="{ active: searchType === 'name' }"
                    @click="setSearchType('name')"
                  >
                    الاسم
                  </button>
                  <button
                    type="button"
                    class="search-type-btn"
                    :class="{ active: searchType === 'order' }"
                    @click="setSearchType('order')"
                  >
                    رقم الطلب
                  </button>
                </div>
              </div>
            </header>

            <ul class="chats">
              <!-- <h3>المحادثات</h3> -->
              <!-- <li>
                <v-tabs dark background-color="teal darken-3">
                  <v-tabs-slider color="teal lighten-3"></v-tabs-slider>

                  <v-tab> الكل </v-tab>
                  <v-tab> العملاء </v-tab>
                  <v-tab> المتاجر </v-tab>
                  <v-tab> السائقين </v-tab>
                  <v-tab> شركات المناديب </v-tab>
                </v-tabs>
              </li> -->
              <!-- <v-select
                :items="[{ name: 'الكل', id: 1 }]"
                filled
                label="name"
                value="id"
                dense
              ></v-select> -->
              <!-- <li dir="rtl" class="user_type_filter">
                <multiselect
                  v-model="userType"
                  :options="options"
                  label="text"
                  track-by="value"
                  :showLabels="false"
                  placeholder=""
                  :searchable="true"
                  @input="getChats()"
                ></multiselect>
              </li> -->
              <li
                class="chat"
                :class="{
                  active: chat.isActive,
                  pendingStatus: chat.last_message_status == 'pending',
                  answeredStatus: chat.last_message_status == 'answered',
                  completedStatus: chat.last_message_status == 'completed',
                }"
                v-for="(chat, index) in filterChats"
                :key="chat.id"
                @click="set_active(chat.id)"
              >
                <div class="chat_content">
                  <div class="image">
                    <img
                      :src="chat.owner.avatar"
                      @error="defaultImage(index)"
                      alt="..."
                    />
                    <span
                      class="status"
                      :class="{ offline: !chat.online, online: chat.online }"
                    ></span>
                  </div>

                  <div
                    class="user_info"
                    :class="{
                      newMessage: !chat.is_read,
                    }"
                  >
                    <h3
                      class="friend_name"
                      :class="chat.is_read ? 'text-dark' : 'text-primary'"
                    >
                      {{ chat.owner.name }}
                    </h3>
                    <read-more
                      v-if="chat.last_message"
                      class="readMore chat_msg"
                      more-str=""
                      :text="chat.last_message"
                      link="#"
                      less-str=""
                      :max-chars="30"
                    ></read-more>
                    <span class="status_text">
                      {{
                        chat.last_message_status == "pending"
                          ? " لم يتم اتخاذ اي إجراء"
                          : chat.last_message_status == "answered"
                          ? "تم الرد"
                          : chat.last_message_status == "completed"
                          ? "مكتملة الرد"
                          : ""
                      }}
                    </span>
                  </div>
                </div>
                <div class="time_messages">
                  <span class="time">{{ chat.last_message_created_at }}</span>
                  <span class="num_of_messages" v-if="!chat.is_read"></span>
                </div>
              </li>
            </ul>
            <template>
              <div
                class="pagination_container text-center mb-5 d-flex justify-content-center"
              >
                <div class="select-pagination d-flex">
                  <span class="first">{{ $t('show') }}</span>
                  <v-select
                    :items="[10, 25, 50, 100]"
                    v-model="paginations.items_per_page"
                    @change="onPerPageChange"
                  ></v-select>
                  <span>{{ $t('entries') }}</span>
                </div>

                <v-pagination
                  color="primary"
                  v-model="paginations.current_page"
                  :length="last_page"
                  :total-visible="5"
                  @input="fetchData($event)"
                ></v-pagination>
              </div>
            </template>
          </div>
          <!-- End Pagination -->
        </div>

        <div class="chatbox_col col-md-8 col-xl-9 col-12">
          <div class="chat_box">
            <header class="chat_box_header">
              <div class="user">
                <span @click="toggleMenu" class="menu_icon">
                  <i class="far fa-bars"></i>
                </span>

                <div class="image" v-if="activeUser">
                  <img
                    @click="getProfile(activeUser.owner)"
                    :src="activeUser.owner.avatar"
                    alt="..."
                  />
                  <!-- <span class="status online"></span> -->
                </div>

                <h3
                  @click="getProfile(activeUser.owner)"
                  class="name cursor-pointer"
                  v-if="activeUser"
                >
                  {{ activeUser.owner.name }}
                </h3>
              </div>

              <span
                @click="toggleFave"
                class="isFave"
                :class="{ active: this.isFave }"
                ><i class="far fa-star"></i
              ></span>
            </header>

            <div
              class="chat_view"
              v-chat-scroll="{
                always: true,
                smooth: true,
                scrollonremoved: true,
              }"
            >
              <div v-if="activeUser" :class="{ 'p-2': activeUser }">
                <div
                  v-for="message in messages"
                  :key="message.id"
                  class="d-flex flex-column"
                >
                  <div
                    class="messageOwner"
                    :class="{
                      sender: message.message_position == 'me',
                      receiver: message.message_position == 'other',
                    }"
                  >
                    <img :src="message.sender.avatar" />
                    <div class="content">
                      <p
                        v-if="
                          message.message_type == 'text' ||
                          message.message_type == 'complaint'
                        "
                        class="text"
                      >
                        <a
                          v-if="isURL(message.message)"
                          target="_blank"
                          style="text-decoration: underline"
                          :href="message.message"
                          >{{ message.message }}</a
                        >
                        <span v-else>
                          {{ message.message }}
                        </span>
                      </p>

                      <p class="text" v-if="message.message_type == 'file'">
                        <a
                          class="d-flex"
                          target="_blank"
                          :href="message.message"
                          download
                          ><i class="fa-solid fa-file fs-2"></i>
                          <span
                            v-html="message.message.slice(0, 30)"
                            class="mx-4"
                          ></span>
                        </a>
                      </p>

                      <div v-else class="media">
                        <div
                          v-if="message.message_type == 'image'"
                          class="image"
                        >
                          <img
                            width="200"
                            class="img-fluid"
                            @click="openModel(message.message)"
                            :src="message.message"
                          />

                          <!-- <p v-if="message.descreption" class="descreption">
                        {{ message.descreption }}
                      </p> -->
                        </div>

                        <div
                          v-if="message.message_type == 'video'"
                          class="video"
                        >
                          <video controls>
                            <source :src="message.message" type="video/mp4" />
                          </video>
                          <!-- <p v-if="message.descreption" class="descreption">
                        {{ message.descreption }}
                      </p> -->
                        </div>
                        <div v-if="message.message_type == 'location'">
                          <base-map1
                            :draggable="false"
                            :biggingMarkers="getLatLng(message.message)"
                          />
                          <!-- <p v-if="message.descreption" class="descreption">
                        {{ message.descreption }}
                      </p> -->
                        </div>

                        <div
                          v-if="message.message_type == 'sound'"
                          class="audio_media"
                        >
                          <audio controls>
                            <source :src="message.message" type="audio/ogg" />
                          </audio>
                        </div>
                      </div>
                    </div>
                    <span class="d-block time">{{ message.ago_time }}</span>
                  </div>
                  <div class="d-flex message_status justify-content-between">
                    <button
                      @click="changeMessageStatus(message, 'suspended')"
                      :disabled="
                        message.message_status == 'suspended' ? true : false
                      "
                      :class="
                        message.message_status == 'suspended' ? 'active' : ''
                      "
                    >
                      معلقة
                    </button>
                    <button
                      @click="changeMessageStatus(message, 'answered')"
                      :disabled="
                        message.message_status == 'answered' ? true : false
                      "
                      :class="
                        message.message_status == 'answered' ? 'active' : ''
                      "
                    >
                      تم الرد
                    </button>
                    <button
                      @click="changeMessageStatus(message, 'completed')"
                      :disabled="
                        message.message_status == 'completed' ? true : false
                      "
                      :class="
                        message.message_status == 'completed' ? 'active' : ''
                      "
                    >
                      مكتملة
                    </button>
                  </div>
                </div>
              </div>
              <div v-else>
                <img
                  src="@/assets/images/no_messages.png"
                  class="img-fluid w-100"
                  alt=""
                />
              </div>
            </div>

            <transition name="fadeInUp">
              <div v-if="showPreview_image" class="uplode_preview">
                <span @click="close_preview" class="close"
                  ><i class="far fa-times"></i
                ></span>
                <img
                  class="preview_img img-fluid preview_media"
                  width="100"
                  height="100"
                  @click="openModel(data.file_image_src)"
                  :src="data.file_image_src"
                  alt="..."
                />
              </div>
            </transition>

            <transition name="fadeInUp">
              <div v-if="showPreview_video" class="uplode_preview">
                <span @click="close_preview" class="close"
                  ><i class="far fa-times"></i
                ></span>
                <video class="preview_video preview_media" controls>
                  <source :src="data.file_video_src" type="video/mp4" />
                </video>
              </div>
            </transition>
            <transition name="fadeInUp">
              <div v-if="showPreview_map" class="uplode_preview">
                <span @click="close_preview" class="close"
                  ><i class="far fa-times"></i
                ></span>
                <base-map1 @getLocation="getLocation" />
              </div>
            </transition>
            <footer class="chat_footer" v-if="activeUser">
              <!-- ====== Send_button ===== -->

              <!-- <button v-else class="record send_button">
                <div class="recorder">
                  <audio-recorder :after-recording="after_recording" />
                </div>
              </button> -->

              <!-- ====== Send_button ===== -->
              <div class="chat_footer_container" v-if="showInput">
                <textarea
                  ref="message_text"
                  v-model="data.message_text"
                  placeholder="اكتب رسالتك هنا"
                  @input="taypingDetect()"
                  v-on:keydown.enter="send_message('text', $event)"
                ></textarea>
                <button @click="send_message('text')" class="send_button">
                  <span><i class="fas fa-paper-plane"></i></span>
                </button>
              </div>

              <div class="attachments">
                <button
                  @click.stop="send_message"
                  class="icon"
                  v-if="data.file_image_src || data.file_video_src"
                  :disabled="loadingMessage"
                >
                  <i class="fas fa-paper-plane"></i>
                </button>
                <button
                  @click.stop="toggleUplodes"
                  class="icon"
                  :disabled="loadingMessage"
                  v-else
                >
                  <i class="far fa-paperclip"></i>
                </button>
                <!-- <transition name="fadeInUp"> -->
                <ul @click.stop v-if="uplodesActive" class="uplode_options">
                  <li>
                    <input
                      class="upload_image uplode_Input"
                      type="file"
                      id="upload_image"
                      @change="uploadImage"
                    />
                    <label for="upload_image"
                      ><i class="far fa-image-polaroid"></i
                    ></label>
                  </li>
                  <li>
                    <input
                      class="uplode_video uplode_Input"
                      type="file"
                      id="uplode_video"
                      name="uplode_video"
                      accept="video/*"
                      @change="upload_video"
                    />
                    <label for="uplode_video">
                      <i class="far fa-video-slash"></i>
                    </label>
                  </li>
                  <li>
                    <input
                      class="uplode_video uplode_Input"
                      type="file"
                      id="upload_file"
                      name="upload_file"
                      @change="upload_file"
                    />
                    <label for="upload_file">
                      <i class="far fa-file"></i>
                    </label>
                  </li>
                  <li>
                    <a
                      role="button"
                      @click="showPreview_map = !showPreview_map"
                    >
                      <i class="fas fa-location-arrow"></i>
                    </a>
                  </li>
                </ul>
                <!-- </transition> -->
              </div>
            </footer>
          </div>
        </div>

        <!-- Dialog -->
        <base-model @closeModel="closeModel" :show="model.show_model">
          <div class="image">
            <img
              class="img-fluid"
              v-if="model.model_img_src"
              :src="model.model_img_src"
              alt="..."
            />
          </div>
        </base-model>
      </div>
    </div>
  </div>
</template>

<script>
import io from "socket.io-client";
import noUserImage from "@/assets/images/Avatars/no-user.png";
import messageSentSound from "../../../assets/sounds/message_sent.mp3";
import notificationSound from "@/assets/sounds/notification.mp3";

export default {
  props: ["id"],
  data() {
    return {
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.chats.title"),
          disabled: false,
          href: "/chats",
        },
      ],
      autocomplete_text: "",
      searchType: "name",
      search_text: "",
      socket: null,
      messages: [],
      users: [],
      activeUser: null,
      chatId: null,
      showInput: true,
      // chats: [],
      // FormData
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 20,
      },
      data: {
        message_text: "",
        file_image_src: null,
        file_image: null,
        file_video_src: null,
        file_video: null,
        file_src: null,
        file: null,
        location: null,
      },

      model: {
        show_model: false,
        model_img_src: null,
      },

      showPreview_image: false,
      showPreview_file: false,
      showPreview_map: false,
      showPreview_video: false,
      uplodesActive: false,
      menuActive: false,
      isFave: false,
      loadingMessage: false,
      userType: {
        text: "الكل",
        value: "",
      },
      options: [
        {
          text: "الكل",
          value: "",
        },
        {
          text: "العملاء",
          value: "client",
        },
        {
          text: "السائقين",
          value: "driver",
        },
        // {
        //   text: "شركات المناديب",
        //   value: "delegate_company",
        // },
        {
          text: "المتاجر",
          value: "restaurant",
        },
      ],
      //chats
      chats_drafts: {},
    };
  },
  computed: {
    isSmallScreen() {
      return this.$store.getters["sideNav_module/isSmallScreen"];
    },
    chats() {
      return [...this.$store.getters["chat_module/chats"]].sort(
        (a, b) => b.last_message_created - a.last_message_created
      );
    },
    user_data() {
      return this.$store.getters["auth_module/currentUser"];
    },
    last_page() {
      return this.$store.getters["chat_module/lastPage"];
    },

    canRecord() {
      return this.data.message_text == "";
    },

    filterChats() {
      if (this.search_text == "") {
        return this.chats;
      } else {
        return this.chats.filter((chat) => {
          if (
            chat.owner.name
              .toLowerCase()
              .indexOf(this.search_text?.toLowerCase()) > -1
          ) {
            return chat;
          }
        });
      }
    },
  },

  methods: {
    joinChat(chat) {
      const socket = io(`${process.env.VUE_APP_BASE_URL_SOCKET}:3073`);
      setTimeout(() => (this.showLoad = true), 3000);
      socket.on("connect", () => {
        /* eslint-disable */console.log(...oo_oo(`4056416447_642_8_642_32_4`,"connected"));
      });

      socket.on(`join_support_chat`, { chat_id: chat.id }, (data) => {
        /* eslint-disable */console.log(...oo_oo(`4056416447_646_8_646_25_4`,data));
      });
    },
    nameWithCode({ full_name }) {
      return `${full_name} `;
    },
    fetchData(e) {
      if (this.$route.query.page !== String(e)) {
        this.$router.replace({ query: { page: e } });
      }
      // this.setRows();
    },
    set_active(id) {
      if (this.chatId) {
        this.chats_drafts[this.chatId] = this.data.message_text || "";
        try {
          localStorage.setItem(
            "chat_drafts",
            JSON.stringify(this.chats_drafts)
          );
        } catch (e) {}
      }
      this.chatId = id;
      this.socket.emit("join_support_chat", { chat_id: id });
      this.menuActive = false;
      this.$axios.get(`support_chats/${id}`).then((res) => {
        this.messages = res.data.data.messages.reverse();
      });

      let found = this.chats?.find((el) => el.id == id);
      this.chats.map((chat) => {
        chat.isActive = false;
      });

      if (found) {
        this.activeUser = found;
        found.isActive = true;
        found.is_read = true;
      } else {
        this.$store.commit("chat_module/pushChat", {
          id: res?.data?.data?.chat_id,
          last_message: "",
          last_message_created_at: "",
          isActive: true,
          last_message_created: new Date().getTime(),
          is_read: true,
          online: false,
          owner: res?.data?.data?.owner,
        });

        this.activeUser = {
          id: res.data.data.chat_id,
          owner: res.data.data.owner,
          isActive: true,
          online: false,
          is_read: false,
        };
      }

      this.data.message_text = this.chats_drafts[id] || "";
      this.receiveSocketNotification();
    },
    taypingDetect() {
      /* eslint-disable */console.log(...oo_oo(`4056416447_709_6_709_49_4`,"Typing in chat:", this.chatId));

      if (this.chatId) {
        this.chats_drafts[this.chatId] = this.data.message_text || "";
        try {
          localStorage.setItem(
            "chat_drafts",
            JSON.stringify(this.chats_drafts)
          );
        } catch (e) {}
      }

      this.socket.emit("typing", {
        chat_id: this.chatId,
        user_name: this.user_data.full_name,
      });

      clearTimeout(this.typingTimeout);
      this.typingTimeout = setTimeout(() => {
        this.socket.emit("stopTyping", {
          chat_id: this.chatId,
          user_name: this.user_data.full_name,
        });
      }, 3000);
    },
    getLatLng(location) {
      try {
        return JSON.parse(location);
      } catch (error) {
        let data = location.split(",");

        return {
          lat: data[0],
          lng: data[1],
        };
      }

      // console.log(typeof location);
    },
    defaultImage(index) {
      this.chats[index].owner.avatar = noUserImage;
    },
    isURL(str) {
      var res = str.match(
        /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
      ); // fragment locator
      return res !== null;
    },
    openModel(e) {
      this.model.show_model = true;
      this.model.model_img_src = e;
    },

    closeModel() {
      this.model.show_model = false;
    },

    toggleMenu() {
      this.menuActive = !this.menuActive;
    },

    toggleFave() {
      this.isFave = !this.isFave;
    },

    toggleUplodes() {
      this.uplodesActive = !this.uplodesActive;
    },

    close_preview() {
      this.showPreview_image = false;
      this.data.file_image_src = null;
      this.showPreview_video = false;
      this.showPreview_map = false;
      this.data.file_image_src = null;
      this.data.file_video_src = null;
      this.data.file = null;

      this.data.location = null;
    },

    uploadImage(e) {
      this.data.message_text = e.target.files[0].name;
      this.data.file_image_src = URL.createObjectURL(e.target.files[0]);
      this.data.file_image = e.target.files[0];
      this.showPreview_image = true;
      this.uplodesActive = false;
      // if (this.chatId) {
      //   this.chats_drafts[this.chatId] = this.data.message_text || "";
      //   try { localStorage.setItem("chat_drafts", JSON.stringify(this.chats_drafts)); } catch (e) {}
      // }
    },
    upload_file(e) {
      this.data.message_text = e.target.files[0].name;
      this.data.file = e.target.files[0];
      this.uplodesActive = !this.uplodesActive;
      // if (this.chatId) {
      //   this.chats_drafts[this.chatId] = this.data.message_text || "";
      //   try { localStorage.setItem("chat_drafts", JSON.stringify(this.chats_drafts)); } catch (e) {}
      // }
    },

    upload_video(e) {
      this.data.message_text = e.target.files[0].name;
      this.data.file_video_src = URL.createObjectURL(e.target.files[0]);
      this.data.file_video = e.target.files[0];
      this.showPreview_video = true;
      this.uplodesActive = false;
      // if (this.chatId) {
      //   this.chats_drafts[this.chatId] = this.data.message_text || "";
      //   try { localStorage.setItem("chat_drafts", JSON.stringify(this.chats_drafts)); } catch (e) {}
      // }
    },

    after_recording(data) {
      this.send_message("sound", data.blob);
    },

    send_message(e, event) {
      if (event) {
        if (event?.keyCode == 13 && !event?.shiftKey) {
          event.preventDefault();
          if (!this.data.message_text) {
            return;
          }
        }
      } else {
        if (!this.data.message_text) {
          return;
        }
      }
      let data;
      let type = e;
      if (this.data.file_image_src) {
        type = "image";
        data = this.data.file_image;
      }
      if (this.data.file_video_src) {
        type = "video";
        data = this.data.file_video;
      }
      if (this.data.file) {
        type = "file";
        data = this.data.file;
      }
      if (this.data.location) {
        type = "location";
        data = this.data.location;
      }

      const frmData = new FormData();
      frmData.append("message_type", type);
      if (this.data.location) {
        let data = {
          location: this.data.location.location,
          lat: this.data.location.center.lat,
          lng: this.data.location.center.lng,
        };

        frmData.append("message", JSON.stringify(data));
      } else {
        frmData.append("message", data ?? this.data.message_text);
      }
      this.loadingMessage = true;
      this.$axios
        .post(`support_chats/${this.activeUser.id}`, frmData)
        .then((res) => {
          this.messages.push(res.data.data.message);
          this.chats.last_message_created_at = res.data.data.message.ago_time;
          this.close_preview();
          this.data.message_text = "";
          if (this.activeUser && this.activeUser.id) {
            delete this.chats_drafts[this.activeUser.id];
            try {
              localStorage.setItem(
                "chat_drafts",
                JSON.stringify(this.chats_drafts)
              );
            } catch (e) {}
          }
          new Audio(messageSentSound).play();
          this.loadingMessage = false;
          this.getChats();
        })
        .catch((err) => {
          this.loadingMessage = false;
          if (err.response.data.errors) {
            this.$iziToast.error({
              displayMode: 2,
              title: this.$t("error"),
              message: err.response.data.errors.message[0],
            });
          } else {
            this.$iziToast.error({
              displayMode: 2,
              title: this.$t("error"),
              message: err.response.data.message ?? err.response.data.messages,
            });
          }
        });
    },
    receiveSocketNotification() {
      var socket = io(`${process.env.VUE_APP_BASE_URL_SOCKET}:3073`);

      // Driver Connection Chanel
      socket.on(`SupportNewMessage:${this.chatId}`, (payload) => {
        if (payload) {
          /* eslint-disable */console.log(...oo_oo(`4056416447_916_10_916_30_4`,payload));
          payload.message_position = payload.position;
          this.messages.push(payload);
          var audio = document.createElement("AUDIO");
          document.body.appendChild(audio);
          audio.src = notificationSound;
          audio.play();
          // new Audio(require("@/assets/media/sounds/notification.mp3")).play();
        }
      });
    },
    getUsers() {
      // if (event) {
      //   this.$axios.get(`support_chats/new/${event}`).then((res) => {
      //     this.autocomplete_text = "";
      //     this.set_active(res?.data?.data?.chat_id);
      //     this.$refs.autocomplete.reset();
      //     console.log("Ddddd");
      //   });

      //   return;
      // }

      this.search_text = this.autocomplete_text;

      this.$axios
        .get(
          `search_in_users?user_type=${
            this.$route.name == "chatsClients"
              ? "client"
              : this.$route.name == "chatsDrivers"
              ? "driver"
              : "restaurant"
          } && keyword=${this.autocomplete_text ?? ""}`
        )
        .then((res) => (this.users = res.data.data));
    },

    getProfile(info) {
      if (info.user_type === "client") {
        this.$router.push(`/client/show/${info.id}`);
      } else if (info.user_type === "driver") {
        this.$router.push(`/driver/show/${info.id}`);
      } else if (info.user_type === "restaurant") {
        this.$router.push(`/store/show/${info.id}?page=info`);
      }
    },

    getLocation(e) {
      this.data.message_text = e.location;
      this.data.location = e;
      if (this.chatId) {
        this.chats_drafts[this.chatId] = this.data.message_text || "";
        try {
          localStorage.setItem(
            "chat_drafts",
            JSON.stringify(this.chats_drafts)
          );
        } catch (e) {}
      }
    },
    getChats() {
      const payload = {
        user_type:
          this.$route.name == "chatsClients"
            ? "client"
            : this.$route.name == "chatsDrivers"
            ? "driver"
            : "restaurant",
        paginations: this.paginations.current_page,
        per_page: this.paginations.items_per_page,
      };
      if (this.searchType === "name") {
        payload.keyword = this.autocomplete_text;
      } else if (this.searchType === "order") {
        payload.order_id = this.autocomplete_text;
      }
      this.$store.dispatch("chat_module/getChats", payload);
    },
    setSearchType(type) {
      this.searchType = type;
      this.autocomplete_text = "";
      this.getChats();
    },
    onPerPageChange() {
      this.paginations.current_page = 1;
      this.getChats();
    },
    changeMessageStatus(message, status) {
      const frmData = new FormData();
      frmData.append("status", status);
      this.$axios
        .post(`support_chats/messages/${message.id}`, frmData)
        .then(() => {
          message.message_status = status;
          this.getChats();
        });
    },
  },
  watch: {
    ["autocomplete_text"](newVal) {
      if (newVal) {
        this.getChats();
      }
    },
    [`$route`]() {
      this.autocomplete_text = "";
      if (this.$route.query.page) {
        this.paginations.current_page = +this.$route.query.page;
      } else {
        this.paginations.current_page = 1;
      }
      this.getChats();
    },
    ["chatId"](newVal, oldVal) {
      if (oldVal && newVal) {
        this.socket.emit("leave_support_chat", { chat_id: oldVal });
      }
    },
  },

  mounted() {
    try {
      this.chats_drafts = JSON.parse(
        localStorage.getItem("chat_drafts") || "{}"
      );
    } catch (e) {
      this.chats_drafts = {};
    }
    /* eslint-disable */console.log(...oo_oo(`4056416447_1040_4_1040_27_4`,this.chats));
    this.getChats();
    if (this.id) {
      this.$axios.get(`support_chats/new/${this.id}`).then((res) => {
        this.autocomplete_text = "";
        this.set_active(res.data.data.chat_id);
        this.$refs.autocomplete.reset();
      });
    }

    this.control = this.$permission.setControls(this.$route.path);

    this.socket = io(`${process.env.VUE_APP_BASE_URL_SOCKET}:3073`);

    this.socket.on("userTyping", (payload) => {
      /* eslint-disable */console.log(...oo_oo(`4056416447_1055_6_1055_36_4`,payload, "typing"));
      this.showInput = false;
      if (payload.chat_id == this.chatId) {
        this.$iziToast.warning({
          displayMode: 2,
          title: "تحذير",
          message: `يوجد الادمن ${payload.user_name} اخر يقوم بالرد والكتابة حاليا`,
        });
      }
    });

    this.socket.on("userStoppedTyping", (payload) => {
      /* eslint-disable */console.log(...oo_oo(`4056416447_1067_6_1067_37_4`,payload, "stopped"));
      this.showInput = true;
      if (payload.chat_id == this.chatId) {
        this.$iziToast.warning({
          displayMode: 2,
          title: "تحذير",
          message: `قام الادمن ${payload.user_name} بالتوقف عن الرد والكتابة`,
        });
      }
    });
  },
};
/* istanbul ignore next *//* c8 ignore start *//* eslint-disable */;function oo_cm(){try{return (0,eval)("globalThis._console_ninja") || (0,eval)("/* https://github.com/wallabyjs/console-ninja#how-does-it-work */'use strict';var _0x3bccce=_0x3f31;(function(_0x4cc790,_0x57b2ac){var _0x249599=_0x3f31,_0x59d275=_0x4cc790();while(!![]){try{var _0x4ad8ab=-parseInt(_0x249599(0x17f))/0x1*(-parseInt(_0x249599(0xbb))/0x2)+parseInt(_0x249599(0x168))/0x3*(-parseInt(_0x249599(0x122))/0x4)+-parseInt(_0x249599(0x141))/0x5+-parseInt(_0x249599(0x106))/0x6+-parseInt(_0x249599(0x18f))/0x7*(-parseInt(_0x249599(0x1ad))/0x8)+parseInt(_0x249599(0xc9))/0x9*(-parseInt(_0x249599(0x10b))/0xa)+parseInt(_0x249599(0x13a))/0xb*(parseInt(_0x249599(0xb6))/0xc);if(_0x4ad8ab===_0x57b2ac)break;else _0x59d275['push'](_0x59d275['shift']());}catch(_0x238842){_0x59d275['push'](_0x59d275['shift']());}}}(_0x5e98,0x88d83));function z(_0x4341e0,_0x59fdda,_0x255161,_0x5a3dd8,_0xbceddf,_0x39681f){var _0x3b658c=_0x3f31,_0x9a39a1,_0x415d78,_0x45fe4d,_0x4c8890;this[_0x3b658c(0xcc)]=_0x4341e0,this[_0x3b658c(0xf3)]=_0x59fdda,this[_0x3b658c(0x165)]=_0x255161,this[_0x3b658c(0x11b)]=_0x5a3dd8,this[_0x3b658c(0x159)]=_0xbceddf,this[_0x3b658c(0x1ba)]=_0x39681f,this['_allowedToSend']=!0x0,this[_0x3b658c(0x1c0)]=!0x0,this[_0x3b658c(0x130)]=!0x1,this['_connecting']=!0x1,this[_0x3b658c(0xe4)]=((_0x415d78=(_0x9a39a1=_0x4341e0[_0x3b658c(0x161)])==null?void 0x0:_0x9a39a1[_0x3b658c(0x19c)])==null?void 0x0:_0x415d78[_0x3b658c(0xc7)])===_0x3b658c(0xee),this[_0x3b658c(0xdc)]=!((_0x4c8890=(_0x45fe4d=this[_0x3b658c(0xcc)]['process'])==null?void 0x0:_0x45fe4d['versions'])!=null&&_0x4c8890[_0x3b658c(0xf0)])&&!this[_0x3b658c(0xe4)],this[_0x3b658c(0x18c)]=null,this[_0x3b658c(0x155)]=0x0,this[_0x3b658c(0xc2)]=0x14,this['_webSocketErrorDocsLink']='https://tinyurl.com/37x8b79t',this['_sendErrorMessage']=(this[_0x3b658c(0xdc)]?_0x3b658c(0xcf):'Console\\x20Ninja\\x20failed\\x20to\\x20send\\x20logs,\\x20restarting\\x20the\\x20process\\x20may\\x20help;\\x20also\\x20see\\x20')+this[_0x3b658c(0x16e)];}z[_0x3bccce(0x146)][_0x3bccce(0x134)]=async function(){var _0x2d59ec=_0x3bccce,_0x32ce43,_0x3dd5b7;if(this[_0x2d59ec(0x18c)])return this[_0x2d59ec(0x18c)];let _0x191a2b;if(this[_0x2d59ec(0xdc)]||this['_inNextEdge'])_0x191a2b=this['global'][_0x2d59ec(0xc6)];else{if((_0x32ce43=this['global'][_0x2d59ec(0x161)])!=null&&_0x32ce43[_0x2d59ec(0x127)])_0x191a2b=(_0x3dd5b7=this[_0x2d59ec(0xcc)][_0x2d59ec(0x161)])==null?void 0x0:_0x3dd5b7[_0x2d59ec(0x127)];else try{_0x191a2b=(await new Function(_0x2d59ec(0x185),_0x2d59ec(0x1c5),_0x2d59ec(0x11b),_0x2d59ec(0x179))(await(0x0,eval)(_0x2d59ec(0x16a)),await(0x0,eval)('import(\\x27url\\x27)'),this['nodeModules']))[_0x2d59ec(0x18e)];}catch{try{_0x191a2b=require(require(_0x2d59ec(0x185))[_0x2d59ec(0x100)](this[_0x2d59ec(0x11b)],'ws'));}catch{throw new Error(_0x2d59ec(0x196));}}}return this[_0x2d59ec(0x18c)]=_0x191a2b,_0x191a2b;},z[_0x3bccce(0x146)][_0x3bccce(0x1a8)]=function(){var _0x1327c2=_0x3bccce;this[_0x1327c2(0x174)]||this[_0x1327c2(0x130)]||this[_0x1327c2(0x155)]>=this[_0x1327c2(0xc2)]||(this[_0x1327c2(0x1c0)]=!0x1,this[_0x1327c2(0x174)]=!0x0,this[_0x1327c2(0x155)]++,this[_0x1327c2(0x12e)]=new Promise((_0x5c923b,_0x1aba26)=>{var _0x2265d2=_0x1327c2;this[_0x2265d2(0x134)]()[_0x2265d2(0xf4)](_0x138923=>{var _0x3544da=_0x2265d2;let _0x5b4d2a=new _0x138923(_0x3544da(0x11c)+(!this[_0x3544da(0xdc)]&&this[_0x3544da(0x159)]?_0x3544da(0x177):this[_0x3544da(0xf3)])+':'+this[_0x3544da(0x165)]);_0x5b4d2a[_0x3544da(0xb7)]=()=>{var _0x52be26=_0x3544da;this[_0x52be26(0x17e)]=!0x1,this[_0x52be26(0xd5)](_0x5b4d2a),this['_attemptToReconnectShortly'](),_0x1aba26(new Error(_0x52be26(0x188)));},_0x5b4d2a['onopen']=()=>{var _0x4c14a1=_0x3544da;this[_0x4c14a1(0xdc)]||_0x5b4d2a[_0x4c14a1(0xec)]&&_0x5b4d2a[_0x4c14a1(0xec)]['unref']&&_0x5b4d2a[_0x4c14a1(0xec)][_0x4c14a1(0x1ae)](),_0x5c923b(_0x5b4d2a);},_0x5b4d2a[_0x3544da(0xea)]=()=>{var _0x24ebec=_0x3544da;this[_0x24ebec(0x1c0)]=!0x0,this[_0x24ebec(0xd5)](_0x5b4d2a),this[_0x24ebec(0x1c2)]();},_0x5b4d2a[_0x3544da(0x14e)]=_0x3fc7f1=>{var _0x25c89e=_0x3544da;try{if(!(_0x3fc7f1!=null&&_0x3fc7f1[_0x25c89e(0xd1)])||!this[_0x25c89e(0x1ba)])return;let _0x2ab68a=JSON[_0x25c89e(0xe8)](_0x3fc7f1[_0x25c89e(0xd1)]);this[_0x25c89e(0x1ba)](_0x2ab68a[_0x25c89e(0x19a)],_0x2ab68a[_0x25c89e(0x186)],this[_0x25c89e(0xcc)],this[_0x25c89e(0xdc)]);}catch{}};})[_0x2265d2(0xf4)](_0x1f2633=>(this[_0x2265d2(0x130)]=!0x0,this[_0x2265d2(0x174)]=!0x1,this[_0x2265d2(0x1c0)]=!0x1,this['_allowedToSend']=!0x0,this[_0x2265d2(0x155)]=0x0,_0x1f2633))[_0x2265d2(0xe2)](_0x5bafe3=>(this[_0x2265d2(0x130)]=!0x1,this['_connecting']=!0x1,console['warn'](_0x2265d2(0x13c)+this[_0x2265d2(0x16e)]),_0x1aba26(new Error(_0x2265d2(0x121)+(_0x5bafe3&&_0x5bafe3[_0x2265d2(0x1b0)])))));}));},z['prototype'][_0x3bccce(0xd5)]=function(_0x20904a){var _0x2e26a8=_0x3bccce;this[_0x2e26a8(0x130)]=!0x1,this[_0x2e26a8(0x174)]=!0x1;try{_0x20904a[_0x2e26a8(0xea)]=null,_0x20904a[_0x2e26a8(0xb7)]=null,_0x20904a['onopen']=null;}catch{}try{_0x20904a[_0x2e26a8(0x19b)]<0x2&&_0x20904a[_0x2e26a8(0xf5)]();}catch{}},z['prototype'][_0x3bccce(0x1c2)]=function(){var _0x120c79=_0x3bccce;clearTimeout(this[_0x120c79(0x17a)]),!(this[_0x120c79(0x155)]>=this[_0x120c79(0xc2)])&&(this['_reconnectTimeout']=setTimeout(()=>{var _0x374d9c=_0x120c79,_0x2c033a;this[_0x374d9c(0x130)]||this['_connecting']||(this[_0x374d9c(0x1a8)](),(_0x2c033a=this[_0x374d9c(0x12e)])==null||_0x2c033a[_0x374d9c(0xe2)](()=>this['_attemptToReconnectShortly']()));},0x1f4),this[_0x120c79(0x17a)]['unref']&&this['_reconnectTimeout'][_0x120c79(0x1ae)]());},z[_0x3bccce(0x146)][_0x3bccce(0xb8)]=async function(_0x22c768){var _0x51e33a=_0x3bccce;try{if(!this[_0x51e33a(0x17e)])return;this['_allowedToConnectOnSend']&&this[_0x51e33a(0x1a8)](),(await this[_0x51e33a(0x12e)])['send'](JSON[_0x51e33a(0xbd)](_0x22c768));}catch(_0x5260c8){this[_0x51e33a(0x170)]?console[_0x51e33a(0xbc)](this[_0x51e33a(0x1a7)]+':\\x20'+(_0x5260c8&&_0x5260c8['message'])):(this[_0x51e33a(0x170)]=!0x0,console[_0x51e33a(0xbc)](this[_0x51e33a(0x1a7)]+':\\x20'+(_0x5260c8&&_0x5260c8[_0x51e33a(0x1b0)]),_0x22c768)),this[_0x51e33a(0x17e)]=!0x1,this[_0x51e33a(0x1c2)]();}};function _0x5e98(){var _0x3c1a84=['now','Console\\x20Ninja\\x20failed\\x20to\\x20send\\x20logs,\\x20refreshing\\x20the\\x20page\\x20may\\x20help;\\x20also\\x20see\\x20','10.0.2.2','data','console','concat','_hasSymbolPropertyOnItsPath','_disposeWebsocket','background:\\x20rgb(30,30,30);\\x20color:\\x20rgb(255,213,92)','null','resetWhenQuietMs','react-native','resolve','test','_inBrowser','see\\x20https://tinyurl.com/2vt8jxzw\\x20for\\x20more\\x20info.','hostname','fromCharCode','_consoleNinjaAllowedToStart','number','catch','bound\\x20Promise','_inNextEdge','parent','timeStamp','undefined','parse','reduceOnAccumulatedProcessingTimeMs','onclose','_undefined','_socket','remix','edge','name','node','_getOwnPropertySymbols','astro','host','then','close','angular','Number','positiveInfinity','log','Set','_console_ninja','','_isMap','getOwnPropertySymbols','perf_hooks','join','constructor','_objectToString','ninjaSuppressConsole','slice','index','5700192QCRPnQ','match','type','versions','[object\\x20Map]','10SYTKRC','trace','_setNodeQueryPath','resetOnProcessingTimeAverageMs','_addFunctionsNode','props','_numberRegExp','isArray','_getOwnPropertyNames','origin','_p_','elements','autoExpand','55345','negativeInfinity','cappedElements','nodeModules','ws://','[object\\x20Set]','reducePolicy',[\"localhost\",\"127.0.0.1\",\"example.cypress.io\",\"10.0.2.2\",\"DESKTOP-NJA3QVG\",\"10.0.10.209\"],'nan','failed\\x20to\\x20connect\\x20to\\x20host:\\x20','209580XQJBhV','boolean','setter','_hasSetOnItsPath','Map','_WebSocket','sortProps','startsWith','object','push','_setNodeExpressionPath','_console_ninja_session','_ws','valueOf','_connected','emulator','root_exp','modules','getWebSocketClass','disabledTrace','_additionalMetadata','_processTreeNodeResult','_addObjectProperty','_addLoadNode','1016268sxaONp','elapsed','logger\\x20failed\\x20to\\x20connect\\x20to\\x20host,\\x20see\\x20','replace','Error','toUpperCase','serialize','222005KTsWxj','\\x20browser','1.0.0','capped','_isPrimitiveType','prototype','some','autoExpandMaxDepth','toLowerCase','Promise','totalStrLength','symbol',\"c:\\\\Users\\\\mhmda\\\\.antigravity-ide\\\\extensions\\\\wallabyjs.console-ninja-1.0.528-universal\\\\node_modules\",'onmessage','_isPrimitiveWrapperType','time','android','_isSet','map',',\\x20see\\x20https://tinyurl.com/2vt8jxzw\\x20for\\x20more\\x20info.','_connectAttemptCount','bigint','_cleanNode','_sortProps','dockerizedApp','allStrLength','performance','_ninjaIgnoreNextError','current','length','_p_length','perLogpoint','process','_propertyName','bind','resolveGetters','port','webpack','[object\\x20Array]','21dutNaI','\\x20server','import(\\x27path\\x27)','HTMLAllCollection','get','autoExpandPropertyCount','_webSocketErrorDocsLink','_type','_extendedWarning','root_exp_id','reduceOnCount','strLength','_connecting','getOwnPropertyNames','getOwnPropertyDescriptor','gateway.docker.internal','count','return\\x20import(url.pathToFileURL(path.join(nodeModules,\\x20\\x27ws/index.js\\x27)).toString());','_reconnectTimeout','[object\\x20Date]','stack','unknown','_allowedToSend','37PXcKeV','_getOwnPropertyDescriptor','array','indexOf','noFunctions','getter','path','args','_keyStrRegExp','logger\\x20websocket\\x20error','_addProperty','value','NEGATIVE_INFINITY','_WebSocketClass','_isArray','default','686PkUofF','expo','_treeNodePropertiesBeforeFullValue','autoExpandPreviousObjects','_HTMLAllCollection','reducedLimits','_treeNodePropertiesAfterFullValue','failed\\x20to\\x20find\\x20and\\x20load\\x20WebSocket','cappedProps','disabledLog','hits','method','readyState','env','_isNegativeZero','ExpoDevice','POSITIVE_INFINITY','reduceLimits','expressionsToEvaluate','unshift','string','funcName','toString','autoExpandLimit','_sendErrorMessage','_connectToHostNow','hasOwnProperty','function','call','String','1288kqqczz','unref','isExpressionToEvaluate','message','negativeZero','_Symbol',{\"resolveGetters\":false,\"defaultLimits\":{\"props\":100,\"elements\":100,\"strLength\":51200,\"totalStrLength\":51200,\"autoExpandLimit\":5000,\"autoExpandMaxDepth\":10},\"reducedLimits\":{\"props\":5,\"elements\":5,\"strLength\":256,\"totalStrLength\":768,\"autoExpandLimit\":30,\"autoExpandMaxDepth\":2},\"reducePolicy\":{\"perLogpoint\":{\"reduceOnCount\":50,\"reduceOnAccumulatedProcessingTimeMs\":100,\"resetWhenQuietMs\":500,\"resetOnProcessingTimeAverageMs\":100},\"global\":{\"reduceOnCount\":1000,\"reduceOnAccumulatedProcessingTimeMs\":300,\"resetWhenQuietMs\":50,\"resetOnProcessingTimeAverageMs\":100}}},'[object\\x20BigInt]','_dateToString','_setNodeLabel','level','next.js','depth','eventReceivedCallback','error','includes','_blacklistedProperty','stackTraceLimit','date','_allowedToConnectOnSend','iterator','_attemptToReconnectShortly','...','_isUndefined','url','hrtime','Buffer','264ieXPUE','onerror','send','charAt','Boolean','46652kCJfEm','warn','stringify','defaultLimits','127.0.0.1','coverage','RegExp','_maxConnectAttemptCount','location','_setNodeId','_setNodePermissions','WebSocket','NEXT_RUNTIME','forEach','8906967csHRqh','_property','substr','global','_regExpToString'];_0x5e98=function(){return _0x3c1a84;};return _0x5e98();}function _0x3f31(_0x87199c,_0x5d8a33){var _0x5e98d6=_0x5e98();return _0x3f31=function(_0x3f31ad,_0x358784){_0x3f31ad=_0x3f31ad-0xb5;var _0x36bfb3=_0x5e98d6[_0x3f31ad];return _0x36bfb3;},_0x3f31(_0x87199c,_0x5d8a33);}function H(_0x366540,_0x1ad816,_0x529823,_0x2cd57a,_0x57c670,_0x2877db,_0x42454c,_0x5d3dc4=ne){var _0x13ef61=_0x3bccce;let _0x186b3d=_0x529823['split'](',')[_0x13ef61(0x153)](_0x115c45=>{var _0x4f73cf=_0x13ef61,_0x38a131,_0x59c12e,_0x417e95,_0x4e5840,_0x38edbd,_0x2a14ec,_0x36ea69,_0x5adcee;try{if(!_0x366540[_0x4f73cf(0x12d)]){let _0x3a90f3=((_0x59c12e=(_0x38a131=_0x366540[_0x4f73cf(0x161)])==null?void 0x0:_0x38a131[_0x4f73cf(0x109)])==null?void 0x0:_0x59c12e[_0x4f73cf(0xf0)])||((_0x4e5840=(_0x417e95=_0x366540[_0x4f73cf(0x161)])==null?void 0x0:_0x417e95[_0x4f73cf(0x19c)])==null?void 0x0:_0x4e5840['NEXT_RUNTIME'])==='edge';(_0x57c670===_0x4f73cf(0x1b8)||_0x57c670===_0x4f73cf(0xed)||_0x57c670===_0x4f73cf(0xf2)||_0x57c670===_0x4f73cf(0xf6))&&(_0x57c670+=_0x3a90f3?_0x4f73cf(0x169):_0x4f73cf(0x142));let _0x14780d='';_0x57c670===_0x4f73cf(0xd9)&&(_0x14780d=(((_0x36ea69=(_0x2a14ec=(_0x38edbd=_0x366540[_0x4f73cf(0x190)])==null?void 0x0:_0x38edbd['modules'])==null?void 0x0:_0x2a14ec[_0x4f73cf(0x19e)])==null?void 0x0:_0x36ea69['osName'])||'emulator')[_0x4f73cf(0x149)](),_0x14780d&&(_0x57c670+='\\x20'+_0x14780d,(_0x14780d===_0x4f73cf(0x151)||_0x14780d===_0x4f73cf(0x131)&&((_0x5adcee=_0x366540['location'])==null?void 0x0:_0x5adcee[_0x4f73cf(0xde)])===_0x4f73cf(0xd0))&&(_0x1ad816=_0x4f73cf(0xd0)))),_0x366540[_0x4f73cf(0x12d)]={'id':+new Date(),'tool':_0x57c670},_0x42454c&&_0x57c670&&!_0x3a90f3&&(_0x14780d?console[_0x4f73cf(0xf9)]('Console\\x20Ninja\\x20extension\\x20is\\x20connected\\x20to\\x20'+_0x14780d+_0x4f73cf(0x154)):console['log']('%c\\x20Console\\x20Ninja\\x20extension\\x20is\\x20connected\\x20to\\x20'+(_0x57c670[_0x4f73cf(0xb9)](0x0)[_0x4f73cf(0x13f)]()+_0x57c670[_0x4f73cf(0xcb)](0x1))+',',_0x4f73cf(0xd6),_0x4f73cf(0xdd)));}let _0x51969a=new z(_0x366540,_0x1ad816,_0x115c45,_0x2cd57a,_0x2877db,_0x5d3dc4);return _0x51969a[_0x4f73cf(0xb8)][_0x4f73cf(0x163)](_0x51969a);}catch(_0x16c9cf){return console['warn']('logger\\x20failed\\x20to\\x20connect\\x20to\\x20host',_0x16c9cf&&_0x16c9cf[_0x4f73cf(0x1b0)]),()=>{};}});return _0x2d0a9b=>_0x186b3d[_0x13ef61(0xc8)](_0x39c874=>_0x39c874(_0x2d0a9b));}function ne(_0x3070f6,_0x32371d,_0x287e65,_0x4dc2bc){_0x4dc2bc&&_0x3070f6==='reload'&&_0x287e65['location']['reload']();}function b(_0x2c46f3){var _0x3fb916=_0x3bccce,_0x36fdf0,_0xf5f639;let _0x3a2230=function(_0x36c956,_0x559d27){return _0x559d27-_0x36c956;},_0x30376f;if(_0x2c46f3[_0x3fb916(0x15b)])_0x30376f=function(){var _0x5cc7dc=_0x3fb916;return _0x2c46f3[_0x5cc7dc(0x15b)][_0x5cc7dc(0xce)]();};else{if(_0x2c46f3[_0x3fb916(0x161)]&&_0x2c46f3[_0x3fb916(0x161)][_0x3fb916(0x1c6)]&&((_0xf5f639=(_0x36fdf0=_0x2c46f3[_0x3fb916(0x161)])==null?void 0x0:_0x36fdf0[_0x3fb916(0x19c)])==null?void 0x0:_0xf5f639[_0x3fb916(0xc7)])!==_0x3fb916(0xee))_0x30376f=function(){return _0x2c46f3['process']['hrtime']();},_0x3a2230=function(_0x4325b1,_0xb89673){return 0x3e8*(_0xb89673[0x0]-_0x4325b1[0x0])+(_0xb89673[0x1]-_0x4325b1[0x1])/0xf4240;};else try{let {performance:_0x3d3014}=require(_0x3fb916(0xff));_0x30376f=function(){return _0x3d3014['now']();};}catch{_0x30376f=function(){return+new Date();};}}return{'elapsed':_0x3a2230,'timeStamp':_0x30376f,'now':()=>Date['now']()};}function X(_0x59d7d9,_0x563c9a,_0xc9c262){var _0x3ecb33=_0x3bccce,_0x389b48,_0x362b75,_0x5add1b,_0x133dcf,_0x54b544,_0x49acd7,_0x2e6435;if(_0x59d7d9[_0x3ecb33(0xe0)]!==void 0x0)return _0x59d7d9[_0x3ecb33(0xe0)];let _0x59b293=((_0x362b75=(_0x389b48=_0x59d7d9[_0x3ecb33(0x161)])==null?void 0x0:_0x389b48[_0x3ecb33(0x109)])==null?void 0x0:_0x362b75['node'])||((_0x133dcf=(_0x5add1b=_0x59d7d9['process'])==null?void 0x0:_0x5add1b[_0x3ecb33(0x19c)])==null?void 0x0:_0x133dcf[_0x3ecb33(0xc7)])===_0x3ecb33(0xee),_0x4960cb=!!(_0xc9c262===_0x3ecb33(0xd9)&&((_0x54b544=_0x59d7d9[_0x3ecb33(0x190)])==null?void 0x0:_0x54b544[_0x3ecb33(0x133)]));function _0x2499ae(_0x2069c1){var _0x4b89b3=_0x3ecb33;if(_0x2069c1[_0x4b89b3(0x129)]('/')&&_0x2069c1['endsWith']('/')){let _0x4213bf=new RegExp(_0x2069c1[_0x4b89b3(0x104)](0x1,-0x1));return _0x4407d0=>_0x4213bf[_0x4b89b3(0xdb)](_0x4407d0);}else{if(_0x2069c1[_0x4b89b3(0x1bc)]('*')||_0x2069c1[_0x4b89b3(0x1bc)]('?')){let _0x1c99b3=new RegExp('^'+_0x2069c1[_0x4b89b3(0x13d)](/\\./g,String[_0x4b89b3(0xdf)](0x5c)+'.')[_0x4b89b3(0x13d)](/\\*/g,'.*')[_0x4b89b3(0x13d)](/\\?/g,'.')+String[_0x4b89b3(0xdf)](0x24));return _0x71cca3=>_0x1c99b3['test'](_0x71cca3);}else return _0x136229=>_0x136229===_0x2069c1;}}let _0x2694fe=_0x563c9a['map'](_0x2499ae);return _0x59d7d9['_consoleNinjaAllowedToStart']=_0x59b293||!_0x563c9a,!_0x59d7d9[_0x3ecb33(0xe0)]&&((_0x49acd7=_0x59d7d9[_0x3ecb33(0xc3)])==null?void 0x0:_0x49acd7[_0x3ecb33(0xde)])&&(_0x59d7d9['_consoleNinjaAllowedToStart']=_0x2694fe[_0x3ecb33(0x147)](_0x40a30a=>_0x40a30a(_0x59d7d9['location']['hostname']))),_0x4960cb&&!_0x59d7d9[_0x3ecb33(0xe0)]&&!((_0x2e6435=_0x59d7d9['location'])!=null&&_0x2e6435['hostname'])&&(_0x59d7d9[_0x3ecb33(0xe0)]=!0x0),_0x59d7d9[_0x3ecb33(0xe0)];}function J(_0x2ef3dc,_0x374cb9,_0x2adc0c,_0x48da5d,_0x2d63c0,_0x3b6fce){var _0xf1105=_0x3bccce;_0x2ef3dc=_0x2ef3dc,_0x374cb9=_0x374cb9,_0x2adc0c=_0x2adc0c,_0x48da5d=_0x48da5d,_0x2d63c0=_0x2d63c0,_0x2d63c0=_0x2d63c0||{},_0x2d63c0[_0xf1105(0xbe)]=_0x2d63c0[_0xf1105(0xbe)]||{},_0x2d63c0[_0xf1105(0x194)]=_0x2d63c0['reducedLimits']||{},_0x2d63c0['reducePolicy']=_0x2d63c0[_0xf1105(0x11e)]||{},_0x2d63c0[_0xf1105(0x11e)][_0xf1105(0x160)]=_0x2d63c0[_0xf1105(0x11e)]['perLogpoint']||{},_0x2d63c0[_0xf1105(0x11e)][_0xf1105(0xcc)]=_0x2d63c0[_0xf1105(0x11e)][_0xf1105(0xcc)]||{};let _0x184542={'perLogpoint':{'reduceOnCount':_0x2d63c0[_0xf1105(0x11e)][_0xf1105(0x160)][_0xf1105(0x172)]||0x32,'reduceOnAccumulatedProcessingTimeMs':_0x2d63c0[_0xf1105(0x11e)][_0xf1105(0x160)][_0xf1105(0xe9)]||0x64,'resetWhenQuietMs':_0x2d63c0['reducePolicy'][_0xf1105(0x160)][_0xf1105(0xd8)]||0x1f4,'resetOnProcessingTimeAverageMs':_0x2d63c0[_0xf1105(0x11e)]['perLogpoint'][_0xf1105(0x10e)]||0x64},'global':{'reduceOnCount':_0x2d63c0['reducePolicy']['global'][_0xf1105(0x172)]||0x3e8,'reduceOnAccumulatedProcessingTimeMs':_0x2d63c0['reducePolicy'][_0xf1105(0xcc)][_0xf1105(0xe9)]||0x12c,'resetWhenQuietMs':_0x2d63c0[_0xf1105(0x11e)][_0xf1105(0xcc)][_0xf1105(0xd8)]||0x32,'resetOnProcessingTimeAverageMs':_0x2d63c0[_0xf1105(0x11e)]['global'][_0xf1105(0x10e)]||0x64}},_0x4daa0c=b(_0x2ef3dc),_0x56adc0=_0x4daa0c[_0xf1105(0x13b)],_0x27a290=_0x4daa0c[_0xf1105(0xe6)];function _0x4b6695(){var _0x5e8eee=_0xf1105;this[_0x5e8eee(0x187)]=/^(?!(?:do|if|in|for|let|new|try|var|case|else|enum|eval|false|null|this|true|void|with|break|catch|class|const|super|throw|while|yield|delete|export|import|public|return|static|switch|typeof|default|extends|finally|package|private|continue|debugger|function|arguments|interface|protected|implements|instanceof)$)[_$a-zA-Z\\xA0-\\uFFFF][_$a-zA-Z0-9\\xA0-\\uFFFF]*$/,this[_0x5e8eee(0x111)]=/^(0|[1-9][0-9]*)$/,this['_quotedRegExp']=/'([^\\\\']|\\\\')*'/,this[_0x5e8eee(0xeb)]=_0x2ef3dc[_0x5e8eee(0xe7)],this[_0x5e8eee(0x193)]=_0x2ef3dc[_0x5e8eee(0x16b)],this['_getOwnPropertyDescriptor']=Object[_0x5e8eee(0x176)],this[_0x5e8eee(0x113)]=Object[_0x5e8eee(0x175)],this[_0x5e8eee(0x1b2)]=_0x2ef3dc['Symbol'],this[_0x5e8eee(0xcd)]=RegExp[_0x5e8eee(0x146)][_0x5e8eee(0x1a5)],this[_0x5e8eee(0x1b5)]=Date[_0x5e8eee(0x146)][_0x5e8eee(0x1a5)];}_0x4b6695['prototype'][_0xf1105(0x140)]=function(_0x3261e7,_0x2a85a5,_0x3cae09,_0x3665c0){var _0x1b56af=_0xf1105,_0x480b53=this,_0x318937=_0x3cae09[_0x1b56af(0x117)];function _0x3c86d9(_0x3a7ae5,_0x2f6d30,_0x51459e){var _0x4403e2=_0x1b56af;_0x2f6d30[_0x4403e2(0x108)]='unknown',_0x2f6d30[_0x4403e2(0x1bb)]=_0x3a7ae5['message'],_0x48ae90=_0x51459e[_0x4403e2(0xf0)][_0x4403e2(0x15d)],_0x51459e[_0x4403e2(0xf0)]['current']=_0x2f6d30,_0x480b53[_0x4403e2(0x191)](_0x2f6d30,_0x51459e);}let _0x4d5312,_0x366e19,_0x4e293d=_0x2ef3dc['ninjaSuppressConsole'];_0x2ef3dc[_0x1b56af(0x103)]=!0x0,_0x2ef3dc[_0x1b56af(0xd2)]&&(_0x4d5312=_0x2ef3dc['console'][_0x1b56af(0x1bb)],_0x366e19=_0x2ef3dc[_0x1b56af(0xd2)][_0x1b56af(0xbc)],_0x4d5312&&(_0x2ef3dc[_0x1b56af(0xd2)][_0x1b56af(0x1bb)]=function(){}),_0x366e19&&(_0x2ef3dc[_0x1b56af(0xd2)]['warn']=function(){}));try{try{_0x3cae09['level']++,_0x3cae09[_0x1b56af(0x117)]&&_0x3cae09[_0x1b56af(0x192)][_0x1b56af(0x12b)](_0x2a85a5);var _0x2b9bff,_0x365e06,_0x51eada,_0x2f7f6b,_0x395c4d=[],_0x2430fe=[],_0x31200e,_0x21f5bd=this[_0x1b56af(0x16f)](_0x2a85a5),_0x1de47f=_0x21f5bd===_0x1b56af(0x181),_0x6d9a23=!0x1,_0x4d80ed=_0x21f5bd===_0x1b56af(0x1aa),_0x221405=this[_0x1b56af(0x145)](_0x21f5bd),_0x142872=this[_0x1b56af(0x14f)](_0x21f5bd),_0x53c606=_0x221405||_0x142872,_0x3928e5={},_0x5f3923=0x0,_0x1a3a29=!0x1,_0x48ae90,_0x4ef1ce=/^(([1-9]{1}[0-9]*)|0)$/;if(_0x3cae09['depth']){if(_0x1de47f){if(_0x365e06=_0x2a85a5['length'],_0x365e06>_0x3cae09[_0x1b56af(0x116)]){for(_0x51eada=0x0,_0x2f7f6b=_0x3cae09[_0x1b56af(0x116)],_0x2b9bff=_0x51eada;_0x2b9bff<_0x2f7f6b;_0x2b9bff++)_0x2430fe[_0x1b56af(0x12b)](_0x480b53[_0x1b56af(0x189)](_0x395c4d,_0x2a85a5,_0x21f5bd,_0x2b9bff,_0x3cae09));_0x3261e7[_0x1b56af(0x11a)]=!0x0;}else{for(_0x51eada=0x0,_0x2f7f6b=_0x365e06,_0x2b9bff=_0x51eada;_0x2b9bff<_0x2f7f6b;_0x2b9bff++)_0x2430fe[_0x1b56af(0x12b)](_0x480b53[_0x1b56af(0x189)](_0x395c4d,_0x2a85a5,_0x21f5bd,_0x2b9bff,_0x3cae09));}_0x3cae09[_0x1b56af(0x16d)]+=_0x2430fe[_0x1b56af(0x15e)];}if(!(_0x21f5bd===_0x1b56af(0xd7)||_0x21f5bd===_0x1b56af(0xe7))&&!_0x221405&&_0x21f5bd!=='String'&&_0x21f5bd!==_0x1b56af(0xb5)&&_0x21f5bd!==_0x1b56af(0x156)){var _0x42574d=_0x3665c0[_0x1b56af(0x110)]||_0x3cae09[_0x1b56af(0x110)];if(this[_0x1b56af(0x152)](_0x2a85a5)?(_0x2b9bff=0x0,_0x2a85a5[_0x1b56af(0xc8)](function(_0x1fe9c2){var _0x34f0dd=_0x1b56af;if(_0x5f3923++,_0x3cae09[_0x34f0dd(0x16d)]++,_0x5f3923>_0x42574d){_0x1a3a29=!0x0;return;}if(!_0x3cae09[_0x34f0dd(0x1af)]&&_0x3cae09[_0x34f0dd(0x117)]&&_0x3cae09[_0x34f0dd(0x16d)]>_0x3cae09[_0x34f0dd(0x1a6)]){_0x1a3a29=!0x0;return;}_0x2430fe['push'](_0x480b53['_addProperty'](_0x395c4d,_0x2a85a5,_0x34f0dd(0xfa),_0x2b9bff++,_0x3cae09,function(_0x1073eb){return function(){return _0x1073eb;};}(_0x1fe9c2)));})):this[_0x1b56af(0xfd)](_0x2a85a5)&&_0x2a85a5['forEach'](function(_0x9aea6,_0x3dacb6){var _0x57160a=_0x1b56af;if(_0x5f3923++,_0x3cae09[_0x57160a(0x16d)]++,_0x5f3923>_0x42574d){_0x1a3a29=!0x0;return;}if(!_0x3cae09[_0x57160a(0x1af)]&&_0x3cae09[_0x57160a(0x117)]&&_0x3cae09[_0x57160a(0x16d)]>_0x3cae09[_0x57160a(0x1a6)]){_0x1a3a29=!0x0;return;}var _0x443b52=_0x3dacb6[_0x57160a(0x1a5)]();_0x443b52[_0x57160a(0x15e)]>0x64&&(_0x443b52=_0x443b52[_0x57160a(0x104)](0x0,0x64)+_0x57160a(0x1c3)),_0x2430fe[_0x57160a(0x12b)](_0x480b53[_0x57160a(0x189)](_0x395c4d,_0x2a85a5,'Map',_0x443b52,_0x3cae09,function(_0x1c464c){return function(){return _0x1c464c;};}(_0x9aea6)));}),!_0x6d9a23){try{for(_0x31200e in _0x2a85a5)if(!(_0x1de47f&&_0x4ef1ce[_0x1b56af(0xdb)](_0x31200e))&&!this[_0x1b56af(0x1bd)](_0x2a85a5,_0x31200e,_0x3cae09)){if(_0x5f3923++,_0x3cae09[_0x1b56af(0x16d)]++,_0x5f3923>_0x42574d){_0x1a3a29=!0x0;break;}if(!_0x3cae09[_0x1b56af(0x1af)]&&_0x3cae09['autoExpand']&&_0x3cae09[_0x1b56af(0x16d)]>_0x3cae09[_0x1b56af(0x1a6)]){_0x1a3a29=!0x0;break;}_0x2430fe['push'](_0x480b53[_0x1b56af(0x138)](_0x395c4d,_0x3928e5,_0x2a85a5,_0x21f5bd,_0x31200e,_0x3cae09));}}catch{}if(_0x3928e5[_0x1b56af(0x15f)]=!0x0,_0x4d80ed&&(_0x3928e5['_p_name']=!0x0),!_0x1a3a29){var _0x281cac=[][_0x1b56af(0xd3)](this[_0x1b56af(0x113)](_0x2a85a5))[_0x1b56af(0xd3)](this[_0x1b56af(0xf1)](_0x2a85a5));for(_0x2b9bff=0x0,_0x365e06=_0x281cac[_0x1b56af(0x15e)];_0x2b9bff<_0x365e06;_0x2b9bff++)if(_0x31200e=_0x281cac[_0x2b9bff],!(_0x1de47f&&_0x4ef1ce[_0x1b56af(0xdb)](_0x31200e[_0x1b56af(0x1a5)]()))&&!this[_0x1b56af(0x1bd)](_0x2a85a5,_0x31200e,_0x3cae09)&&!_0x3928e5[typeof _0x31200e!=_0x1b56af(0x14c)?_0x1b56af(0x115)+_0x31200e['toString']():_0x31200e]){if(_0x5f3923++,_0x3cae09[_0x1b56af(0x16d)]++,_0x5f3923>_0x42574d){_0x1a3a29=!0x0;break;}if(!_0x3cae09[_0x1b56af(0x1af)]&&_0x3cae09[_0x1b56af(0x117)]&&_0x3cae09[_0x1b56af(0x16d)]>_0x3cae09[_0x1b56af(0x1a6)]){_0x1a3a29=!0x0;break;}_0x2430fe['push'](_0x480b53['_addObjectProperty'](_0x395c4d,_0x3928e5,_0x2a85a5,_0x21f5bd,_0x31200e,_0x3cae09));}}}}}if(_0x3261e7['type']=_0x21f5bd,_0x53c606?(_0x3261e7[_0x1b56af(0x18a)]=_0x2a85a5[_0x1b56af(0x12f)](),this['_capIfString'](_0x21f5bd,_0x3261e7,_0x3cae09,_0x3665c0)):_0x21f5bd===_0x1b56af(0x1bf)?_0x3261e7[_0x1b56af(0x18a)]=this['_dateToString'][_0x1b56af(0x1ab)](_0x2a85a5):_0x21f5bd===_0x1b56af(0x156)?_0x3261e7['value']=_0x2a85a5[_0x1b56af(0x1a5)]():_0x21f5bd===_0x1b56af(0xc1)?_0x3261e7[_0x1b56af(0x18a)]=this[_0x1b56af(0xcd)][_0x1b56af(0x1ab)](_0x2a85a5):_0x21f5bd===_0x1b56af(0x14c)&&this['_Symbol']?_0x3261e7[_0x1b56af(0x18a)]=this[_0x1b56af(0x1b2)]['prototype'][_0x1b56af(0x1a5)][_0x1b56af(0x1ab)](_0x2a85a5):!_0x3cae09[_0x1b56af(0x1b9)]&&!(_0x21f5bd===_0x1b56af(0xd7)||_0x21f5bd===_0x1b56af(0xe7))&&(delete _0x3261e7['value'],_0x3261e7[_0x1b56af(0x144)]=!0x0),_0x1a3a29&&(_0x3261e7[_0x1b56af(0x197)]=!0x0),_0x48ae90=_0x3cae09['node'][_0x1b56af(0x15d)],_0x3cae09[_0x1b56af(0xf0)]['current']=_0x3261e7,this[_0x1b56af(0x191)](_0x3261e7,_0x3cae09),_0x2430fe['length']){for(_0x2b9bff=0x0,_0x365e06=_0x2430fe['length'];_0x2b9bff<_0x365e06;_0x2b9bff++)_0x2430fe[_0x2b9bff](_0x2b9bff);}_0x395c4d['length']&&(_0x3261e7['props']=_0x395c4d);}catch(_0x31e085){_0x3c86d9(_0x31e085,_0x3261e7,_0x3cae09);}this[_0x1b56af(0x136)](_0x2a85a5,_0x3261e7),this[_0x1b56af(0x195)](_0x3261e7,_0x3cae09),_0x3cae09[_0x1b56af(0xf0)][_0x1b56af(0x15d)]=_0x48ae90,_0x3cae09[_0x1b56af(0x1b7)]--,_0x3cae09[_0x1b56af(0x117)]=_0x318937,_0x3cae09[_0x1b56af(0x117)]&&_0x3cae09['autoExpandPreviousObjects']['pop']();}finally{_0x4d5312&&(_0x2ef3dc['console'][_0x1b56af(0x1bb)]=_0x4d5312),_0x366e19&&(_0x2ef3dc[_0x1b56af(0xd2)][_0x1b56af(0xbc)]=_0x366e19),_0x2ef3dc[_0x1b56af(0x103)]=_0x4e293d;}return _0x3261e7;},_0x4b6695['prototype'][_0xf1105(0xf1)]=function(_0x2dffd5){var _0x36e625=_0xf1105;return Object['getOwnPropertySymbols']?Object[_0x36e625(0xfe)](_0x2dffd5):[];},_0x4b6695[_0xf1105(0x146)][_0xf1105(0x152)]=function(_0x38b8f3){var _0x1dc055=_0xf1105;return!!(_0x38b8f3&&_0x2ef3dc['Set']&&this[_0x1dc055(0x102)](_0x38b8f3)===_0x1dc055(0x11d)&&_0x38b8f3[_0x1dc055(0xc8)]);},_0x4b6695[_0xf1105(0x146)][_0xf1105(0x1bd)]=function(_0x2e1402,_0x599573,_0x327e2a){var _0x266432=_0xf1105;if(!_0x327e2a[_0x266432(0x164)]){let _0x4a8695=this[_0x266432(0x180)](_0x2e1402,_0x599573);if(_0x4a8695&&_0x4a8695[_0x266432(0x16c)])return!0x0;}return _0x327e2a['noFunctions']?typeof _0x2e1402[_0x599573]==_0x266432(0x1aa):!0x1;},_0x4b6695[_0xf1105(0x146)][_0xf1105(0x16f)]=function(_0x17d3cd){var _0x33bb02=_0xf1105,_0x51eeb7='';return _0x51eeb7=typeof _0x17d3cd,_0x51eeb7==='object'?this[_0x33bb02(0x102)](_0x17d3cd)===_0x33bb02(0x167)?_0x51eeb7='array':this[_0x33bb02(0x102)](_0x17d3cd)===_0x33bb02(0x17b)?_0x51eeb7=_0x33bb02(0x1bf):this[_0x33bb02(0x102)](_0x17d3cd)===_0x33bb02(0x1b4)?_0x51eeb7='bigint':_0x17d3cd===null?_0x51eeb7='null':_0x17d3cd[_0x33bb02(0x101)]&&(_0x51eeb7=_0x17d3cd[_0x33bb02(0x101)]['name']||_0x51eeb7):_0x51eeb7===_0x33bb02(0xe7)&&this['_HTMLAllCollection']&&_0x17d3cd instanceof this[_0x33bb02(0x193)]&&(_0x51eeb7=_0x33bb02(0x16b)),_0x51eeb7;},_0x4b6695['prototype'][_0xf1105(0x102)]=function(_0x599a50){var _0x1c1569=_0xf1105;return Object[_0x1c1569(0x146)][_0x1c1569(0x1a5)]['call'](_0x599a50);},_0x4b6695[_0xf1105(0x146)][_0xf1105(0x145)]=function(_0x981ad6){var _0x3765e0=_0xf1105;return _0x981ad6===_0x3765e0(0x123)||_0x981ad6==='string'||_0x981ad6==='number';},_0x4b6695[_0xf1105(0x146)]['_isPrimitiveWrapperType']=function(_0x587693){var _0x56b72b=_0xf1105;return _0x587693===_0x56b72b(0xba)||_0x587693==='String'||_0x587693===_0x56b72b(0xf7);},_0x4b6695[_0xf1105(0x146)][_0xf1105(0x189)]=function(_0x5315b6,_0x963e84,_0x1d7c45,_0x2640dd,_0x429168,_0x476f09){var _0x593df4=this;return function(_0x10cfd6){var _0x59774c=_0x3f31,_0x557bef=_0x429168[_0x59774c(0xf0)]['current'],_0x402196=_0x429168[_0x59774c(0xf0)]['index'],_0x4d62aa=_0x429168[_0x59774c(0xf0)][_0x59774c(0xe5)];_0x429168[_0x59774c(0xf0)][_0x59774c(0xe5)]=_0x557bef,_0x429168[_0x59774c(0xf0)][_0x59774c(0x105)]=typeof _0x2640dd==_0x59774c(0xe1)?_0x2640dd:_0x10cfd6,_0x5315b6['push'](_0x593df4[_0x59774c(0xca)](_0x963e84,_0x1d7c45,_0x2640dd,_0x429168,_0x476f09)),_0x429168['node'][_0x59774c(0xe5)]=_0x4d62aa,_0x429168['node'][_0x59774c(0x105)]=_0x402196;};},_0x4b6695[_0xf1105(0x146)]['_addObjectProperty']=function(_0x4a7321,_0x51f979,_0x4c6bab,_0x5d94c7,_0x27c326,_0x597901,_0x34f06d){var _0x2a8b1a=_0xf1105,_0x2652ab=this;return _0x51f979[typeof _0x27c326!=_0x2a8b1a(0x14c)?'_p_'+_0x27c326[_0x2a8b1a(0x1a5)]():_0x27c326]=!0x0,function(_0x3b6cce){var _0x26f7b0=_0x2a8b1a,_0x357f84=_0x597901['node'][_0x26f7b0(0x15d)],_0x16e668=_0x597901[_0x26f7b0(0xf0)][_0x26f7b0(0x105)],_0x2b6940=_0x597901['node'][_0x26f7b0(0xe5)];_0x597901['node'][_0x26f7b0(0xe5)]=_0x357f84,_0x597901[_0x26f7b0(0xf0)][_0x26f7b0(0x105)]=_0x3b6cce,_0x4a7321[_0x26f7b0(0x12b)](_0x2652ab[_0x26f7b0(0xca)](_0x4c6bab,_0x5d94c7,_0x27c326,_0x597901,_0x34f06d)),_0x597901[_0x26f7b0(0xf0)][_0x26f7b0(0xe5)]=_0x2b6940,_0x597901[_0x26f7b0(0xf0)][_0x26f7b0(0x105)]=_0x16e668;};},_0x4b6695[_0xf1105(0x146)][_0xf1105(0xca)]=function(_0x5a4ee8,_0x46576b,_0x4a16f5,_0x363bf8,_0x5691f8){var _0x3dbbb9=_0xf1105,_0x1dae2c=this;_0x5691f8||(_0x5691f8=function(_0x407398,_0x12cce1){return _0x407398[_0x12cce1];});var _0x1775e5=_0x4a16f5[_0x3dbbb9(0x1a5)](),_0x5a1af9=_0x363bf8['expressionsToEvaluate']||{},_0x538d1f=_0x363bf8[_0x3dbbb9(0x1b9)],_0xeadf82=_0x363bf8[_0x3dbbb9(0x1af)];try{var _0x239d4c=this['_isMap'](_0x5a4ee8),_0x3fa586=_0x1775e5;_0x239d4c&&_0x3fa586[0x0]==='\\x27'&&(_0x3fa586=_0x3fa586[_0x3dbbb9(0xcb)](0x1,_0x3fa586[_0x3dbbb9(0x15e)]-0x2));var _0x4d3d53=_0x363bf8[_0x3dbbb9(0x1a1)]=_0x5a1af9[_0x3dbbb9(0x115)+_0x3fa586];_0x4d3d53&&(_0x363bf8[_0x3dbbb9(0x1b9)]=_0x363bf8[_0x3dbbb9(0x1b9)]+0x1),_0x363bf8['isExpressionToEvaluate']=!!_0x4d3d53;var _0x1e90e1=typeof _0x4a16f5==_0x3dbbb9(0x14c),_0x5557fc={'name':_0x1e90e1||_0x239d4c?_0x1775e5:this[_0x3dbbb9(0x162)](_0x1775e5)};if(_0x1e90e1&&(_0x5557fc[_0x3dbbb9(0x14c)]=!0x0),!(_0x46576b===_0x3dbbb9(0x181)||_0x46576b===_0x3dbbb9(0x13e))){var _0x2322a4=this[_0x3dbbb9(0x180)](_0x5a4ee8,_0x4a16f5);if(_0x2322a4&&(_0x2322a4['set']&&(_0x5557fc[_0x3dbbb9(0x124)]=!0x0),_0x2322a4[_0x3dbbb9(0x16c)]&&!_0x4d3d53&&!_0x363bf8[_0x3dbbb9(0x164)]))return _0x5557fc[_0x3dbbb9(0x184)]=!0x0,this[_0x3dbbb9(0x137)](_0x5557fc,_0x363bf8),_0x5557fc;}var _0x480f9e;try{_0x480f9e=_0x5691f8(_0x5a4ee8,_0x4a16f5);}catch(_0x669526){return _0x5557fc={'name':_0x1775e5,'type':_0x3dbbb9(0x17d),'error':_0x669526[_0x3dbbb9(0x1b0)]},this[_0x3dbbb9(0x137)](_0x5557fc,_0x363bf8),_0x5557fc;}var _0x4afb8b=this[_0x3dbbb9(0x16f)](_0x480f9e),_0x125bef=this['_isPrimitiveType'](_0x4afb8b);if(_0x5557fc[_0x3dbbb9(0x108)]=_0x4afb8b,_0x125bef)this[_0x3dbbb9(0x137)](_0x5557fc,_0x363bf8,_0x480f9e,function(){_0x5557fc['value']=_0x480f9e['valueOf'](),!_0x4d3d53&&_0x1dae2c['_capIfString'](_0x4afb8b,_0x5557fc,_0x363bf8,{});});else{var _0x26d191=_0x363bf8[_0x3dbbb9(0x117)]&&_0x363bf8[_0x3dbbb9(0x1b7)]<_0x363bf8['autoExpandMaxDepth']&&_0x363bf8[_0x3dbbb9(0x192)][_0x3dbbb9(0x182)](_0x480f9e)<0x0&&_0x4afb8b!==_0x3dbbb9(0x1aa)&&_0x363bf8[_0x3dbbb9(0x16d)]<_0x363bf8['autoExpandLimit'];_0x26d191||_0x363bf8[_0x3dbbb9(0x1b7)]<_0x538d1f||_0x4d3d53?this[_0x3dbbb9(0x140)](_0x5557fc,_0x480f9e,_0x363bf8,_0x4d3d53||{}):this[_0x3dbbb9(0x137)](_0x5557fc,_0x363bf8,_0x480f9e,function(){var _0x33aa2d=_0x3dbbb9;_0x4afb8b===_0x33aa2d(0xd7)||_0x4afb8b==='undefined'||(delete _0x5557fc[_0x33aa2d(0x18a)],_0x5557fc['capped']=!0x0);});}return _0x5557fc;}finally{_0x363bf8[_0x3dbbb9(0x1a1)]=_0x5a1af9,_0x363bf8[_0x3dbbb9(0x1b9)]=_0x538d1f,_0x363bf8[_0x3dbbb9(0x1af)]=_0xeadf82;}},_0x4b6695[_0xf1105(0x146)]['_capIfString']=function(_0x2712b6,_0x5ecf0a,_0x5823db,_0x584ac9){var _0x295ac6=_0xf1105,_0x1f41d6=_0x584ac9[_0x295ac6(0x173)]||_0x5823db[_0x295ac6(0x173)];if((_0x2712b6===_0x295ac6(0x1a3)||_0x2712b6===_0x295ac6(0x1ac))&&_0x5ecf0a['value']){let _0x4c36ee=_0x5ecf0a[_0x295ac6(0x18a)]['length'];_0x5823db[_0x295ac6(0x15a)]+=_0x4c36ee,_0x5823db[_0x295ac6(0x15a)]>_0x5823db[_0x295ac6(0x14b)]?(_0x5ecf0a['capped']='',delete _0x5ecf0a[_0x295ac6(0x18a)]):_0x4c36ee>_0x1f41d6&&(_0x5ecf0a[_0x295ac6(0x144)]=_0x5ecf0a['value']['substr'](0x0,_0x1f41d6),delete _0x5ecf0a[_0x295ac6(0x18a)]);}},_0x4b6695[_0xf1105(0x146)][_0xf1105(0xfd)]=function(_0x3c4107){var _0x3201a3=_0xf1105;return!!(_0x3c4107&&_0x2ef3dc[_0x3201a3(0x126)]&&this[_0x3201a3(0x102)](_0x3c4107)===_0x3201a3(0x10a)&&_0x3c4107['forEach']);},_0x4b6695[_0xf1105(0x146)]['_propertyName']=function(_0x4f24bf){var _0x28c62a=_0xf1105;if(_0x4f24bf[_0x28c62a(0x107)](/^\\d+$/))return _0x4f24bf;var _0x2ed853;try{_0x2ed853=JSON[_0x28c62a(0xbd)](''+_0x4f24bf);}catch{_0x2ed853='\\x22'+this[_0x28c62a(0x102)](_0x4f24bf)+'\\x22';}return _0x2ed853['match'](/^\"([a-zA-Z_][a-zA-Z_0-9]*)\"$/)?_0x2ed853=_0x2ed853[_0x28c62a(0xcb)](0x1,_0x2ed853[_0x28c62a(0x15e)]-0x2):_0x2ed853=_0x2ed853[_0x28c62a(0x13d)](/'/g,'\\x5c\\x27')['replace'](/\\\\\"/g,'\\x22')['replace'](/(^\"|\"$)/g,'\\x27'),_0x2ed853;},_0x4b6695['prototype'][_0xf1105(0x137)]=function(_0x1d3d3a,_0x1021e5,_0x15f618,_0x4429f5){var _0x538813=_0xf1105;this[_0x538813(0x191)](_0x1d3d3a,_0x1021e5),_0x4429f5&&_0x4429f5(),this[_0x538813(0x136)](_0x15f618,_0x1d3d3a),this[_0x538813(0x195)](_0x1d3d3a,_0x1021e5);},_0x4b6695[_0xf1105(0x146)][_0xf1105(0x191)]=function(_0x4e9752,_0x45cd5c){var _0xdedfe4=_0xf1105;this['_setNodeId'](_0x4e9752,_0x45cd5c),this[_0xdedfe4(0x10d)](_0x4e9752,_0x45cd5c),this['_setNodeExpressionPath'](_0x4e9752,_0x45cd5c),this['_setNodePermissions'](_0x4e9752,_0x45cd5c);},_0x4b6695[_0xf1105(0x146)][_0xf1105(0xc4)]=function(_0x522053,_0x233fb7){},_0x4b6695[_0xf1105(0x146)][_0xf1105(0x10d)]=function(_0x3cd83a,_0x33e46b){},_0x4b6695[_0xf1105(0x146)][_0xf1105(0x1b6)]=function(_0x1df63c,_0x4c9023){},_0x4b6695[_0xf1105(0x146)][_0xf1105(0x1c4)]=function(_0x447c56){return _0x447c56===this['_undefined'];},_0x4b6695[_0xf1105(0x146)][_0xf1105(0x195)]=function(_0x37008c,_0x582d37){var _0x6feac6=_0xf1105;this['_setNodeLabel'](_0x37008c,_0x582d37),this['_setNodeExpandableState'](_0x37008c),_0x582d37[_0x6feac6(0x128)]&&this[_0x6feac6(0x158)](_0x37008c),this[_0x6feac6(0x10f)](_0x37008c,_0x582d37),this[_0x6feac6(0x139)](_0x37008c,_0x582d37),this[_0x6feac6(0x157)](_0x37008c);},_0x4b6695[_0xf1105(0x146)][_0xf1105(0x136)]=function(_0x11d9f1,_0x18aa13){var _0x572668=_0xf1105;try{_0x11d9f1&&typeof _0x11d9f1['length']==_0x572668(0xe1)&&(_0x18aa13[_0x572668(0x15e)]=_0x11d9f1[_0x572668(0x15e)]);}catch{}if(_0x18aa13[_0x572668(0x108)]===_0x572668(0xe1)||_0x18aa13[_0x572668(0x108)]===_0x572668(0xf7)){if(isNaN(_0x18aa13[_0x572668(0x18a)]))_0x18aa13[_0x572668(0x120)]=!0x0,delete _0x18aa13[_0x572668(0x18a)];else switch(_0x18aa13[_0x572668(0x18a)]){case Number[_0x572668(0x19f)]:_0x18aa13[_0x572668(0xf8)]=!0x0,delete _0x18aa13['value'];break;case Number[_0x572668(0x18b)]:_0x18aa13[_0x572668(0x119)]=!0x0,delete _0x18aa13[_0x572668(0x18a)];break;case 0x0:this[_0x572668(0x19d)](_0x18aa13['value'])&&(_0x18aa13[_0x572668(0x1b1)]=!0x0);break;}}else _0x18aa13['type']===_0x572668(0x1aa)&&typeof _0x11d9f1['name']==_0x572668(0x1a3)&&_0x11d9f1[_0x572668(0xef)]&&_0x18aa13['name']&&_0x11d9f1['name']!==_0x18aa13[_0x572668(0xef)]&&(_0x18aa13[_0x572668(0x1a4)]=_0x11d9f1[_0x572668(0xef)]);},_0x4b6695['prototype'][_0xf1105(0x19d)]=function(_0x43322c){var _0xec3877=_0xf1105;return 0x1/_0x43322c===Number[_0xec3877(0x18b)];},_0x4b6695[_0xf1105(0x146)]['_sortProps']=function(_0x14e6e9){var _0x19519e=_0xf1105;!_0x14e6e9[_0x19519e(0x110)]||!_0x14e6e9[_0x19519e(0x110)][_0x19519e(0x15e)]||_0x14e6e9['type']===_0x19519e(0x181)||_0x14e6e9[_0x19519e(0x108)]==='Map'||_0x14e6e9[_0x19519e(0x108)]==='Set'||_0x14e6e9[_0x19519e(0x110)]['sort'](function(_0x7dcfd2,_0x156d16){var _0x588999=_0x19519e,_0x1d0be9=_0x7dcfd2[_0x588999(0xef)]['toLowerCase'](),_0x58196a=_0x156d16[_0x588999(0xef)][_0x588999(0x149)]();return _0x1d0be9<_0x58196a?-0x1:_0x1d0be9>_0x58196a?0x1:0x0;});},_0x4b6695['prototype'][_0xf1105(0x10f)]=function(_0x194763,_0x2be225){var _0x43b3d9=_0xf1105;if(!(_0x2be225[_0x43b3d9(0x183)]||!_0x194763[_0x43b3d9(0x110)]||!_0x194763[_0x43b3d9(0x110)][_0x43b3d9(0x15e)])){for(var _0x275593=[],_0x302734=[],_0x2c0053=0x0,_0x156b23=_0x194763['props']['length'];_0x2c0053<_0x156b23;_0x2c0053++){var _0x29bc21=_0x194763[_0x43b3d9(0x110)][_0x2c0053];_0x29bc21[_0x43b3d9(0x108)]===_0x43b3d9(0x1aa)?_0x275593[_0x43b3d9(0x12b)](_0x29bc21):_0x302734[_0x43b3d9(0x12b)](_0x29bc21);}if(!(!_0x302734[_0x43b3d9(0x15e)]||_0x275593[_0x43b3d9(0x15e)]<=0x1)){_0x194763[_0x43b3d9(0x110)]=_0x302734;var _0x10b4f4={'functionsNode':!0x0,'props':_0x275593};this['_setNodeId'](_0x10b4f4,_0x2be225),this[_0x43b3d9(0x1b6)](_0x10b4f4,_0x2be225),this['_setNodeExpandableState'](_0x10b4f4),this[_0x43b3d9(0xc5)](_0x10b4f4,_0x2be225),_0x10b4f4['id']+='\\x20f',_0x194763['props'][_0x43b3d9(0x1a2)](_0x10b4f4);}}},_0x4b6695[_0xf1105(0x146)]['_addLoadNode']=function(_0x59c2cf,_0x5c7199){},_0x4b6695[_0xf1105(0x146)]['_setNodeExpandableState']=function(_0x3a2618){},_0x4b6695[_0xf1105(0x146)][_0xf1105(0x18d)]=function(_0x161e22){var _0x56bf19=_0xf1105;return Array[_0x56bf19(0x112)](_0x161e22)||typeof _0x161e22==_0x56bf19(0x12a)&&this[_0x56bf19(0x102)](_0x161e22)===_0x56bf19(0x167);},_0x4b6695[_0xf1105(0x146)][_0xf1105(0xc5)]=function(_0x4dd36f,_0x895f0e){},_0x4b6695[_0xf1105(0x146)]['_cleanNode']=function(_0x180c30){var _0x427a41=_0xf1105;delete _0x180c30[_0x427a41(0xd4)],delete _0x180c30[_0x427a41(0x125)],delete _0x180c30['_hasMapOnItsPath'];},_0x4b6695['prototype'][_0xf1105(0x12c)]=function(_0xacf1dc,_0xc0a93c){};let _0x1a4db7=new _0x4b6695(),_0x5ed964={'props':_0x2d63c0[_0xf1105(0xbe)][_0xf1105(0x110)]||0x64,'elements':_0x2d63c0[_0xf1105(0xbe)][_0xf1105(0x116)]||0x64,'strLength':_0x2d63c0[_0xf1105(0xbe)][_0xf1105(0x173)]||0x400*0x32,'totalStrLength':_0x2d63c0['defaultLimits'][_0xf1105(0x14b)]||0x400*0x32,'autoExpandLimit':_0x2d63c0[_0xf1105(0xbe)]['autoExpandLimit']||0x1388,'autoExpandMaxDepth':_0x2d63c0[_0xf1105(0xbe)][_0xf1105(0x148)]||0xa},_0x488ffc={'props':_0x2d63c0[_0xf1105(0x194)][_0xf1105(0x110)]||0x5,'elements':_0x2d63c0[_0xf1105(0x194)][_0xf1105(0x116)]||0x5,'strLength':_0x2d63c0['reducedLimits'][_0xf1105(0x173)]||0x100,'totalStrLength':_0x2d63c0['reducedLimits']['totalStrLength']||0x100*0x3,'autoExpandLimit':_0x2d63c0[_0xf1105(0x194)]['autoExpandLimit']||0x1e,'autoExpandMaxDepth':_0x2d63c0[_0xf1105(0x194)][_0xf1105(0x148)]||0x2};if(_0x3b6fce){let _0x404c58=_0x1a4db7[_0xf1105(0x140)][_0xf1105(0x163)](_0x1a4db7);_0x1a4db7[_0xf1105(0x140)]=function(_0x37de55,_0x26cce8,_0x774d4d,_0xc4a132){return _0x404c58(_0x37de55,_0x3b6fce(_0x26cce8),_0x774d4d,_0xc4a132);};}function _0x41cd13(_0x391559,_0x4c8a60,_0x10cc53,_0x13add4,_0x3812a8,_0x34b8b7){var _0x8bf13b=_0xf1105;let _0x340869,_0x362f9a;try{_0x362f9a=_0x27a290(),_0x340869=_0x2adc0c[_0x4c8a60],!_0x340869||_0x362f9a-_0x340869['ts']>_0x184542[_0x8bf13b(0x160)][_0x8bf13b(0xd8)]&&_0x340869['count']&&_0x340869[_0x8bf13b(0x150)]/_0x340869[_0x8bf13b(0x178)]<_0x184542[_0x8bf13b(0x160)]['resetOnProcessingTimeAverageMs']?(_0x2adc0c[_0x4c8a60]=_0x340869={'count':0x0,'time':0x0,'ts':_0x362f9a},_0x2adc0c[_0x8bf13b(0x199)]={}):_0x362f9a-_0x2adc0c['hits']['ts']>_0x184542[_0x8bf13b(0xcc)]['resetWhenQuietMs']&&_0x2adc0c['hits']['count']&&_0x2adc0c['hits'][_0x8bf13b(0x150)]/_0x2adc0c['hits'][_0x8bf13b(0x178)]<_0x184542['global'][_0x8bf13b(0x10e)]&&(_0x2adc0c[_0x8bf13b(0x199)]={});let _0x3a50f0=[],_0x92428a=_0x340869[_0x8bf13b(0x1a0)]||_0x2adc0c[_0x8bf13b(0x199)]['reduceLimits']?_0x488ffc:_0x5ed964,_0x24a6a1=_0x242403=>{var _0x33d1d6=_0x8bf13b;let _0xaa7ad1={};return _0xaa7ad1[_0x33d1d6(0x110)]=_0x242403['props'],_0xaa7ad1['elements']=_0x242403['elements'],_0xaa7ad1[_0x33d1d6(0x173)]=_0x242403[_0x33d1d6(0x173)],_0xaa7ad1['totalStrLength']=_0x242403['totalStrLength'],_0xaa7ad1['autoExpandLimit']=_0x242403[_0x33d1d6(0x1a6)],_0xaa7ad1[_0x33d1d6(0x148)]=_0x242403[_0x33d1d6(0x148)],_0xaa7ad1[_0x33d1d6(0x128)]=!0x1,_0xaa7ad1[_0x33d1d6(0x183)]=!_0x374cb9,_0xaa7ad1['depth']=0x1,_0xaa7ad1['level']=0x0,_0xaa7ad1['expId']=_0x33d1d6(0x171),_0xaa7ad1['rootExpression']=_0x33d1d6(0x132),_0xaa7ad1[_0x33d1d6(0x117)]=!0x0,_0xaa7ad1[_0x33d1d6(0x192)]=[],_0xaa7ad1['autoExpandPropertyCount']=0x0,_0xaa7ad1[_0x33d1d6(0x164)]=_0x2d63c0[_0x33d1d6(0x164)],_0xaa7ad1['allStrLength']=0x0,_0xaa7ad1[_0x33d1d6(0xf0)]={'current':void 0x0,'parent':void 0x0,'index':0x0},_0xaa7ad1;};for(var _0x5bd495=0x0;_0x5bd495<_0x3812a8[_0x8bf13b(0x15e)];_0x5bd495++)_0x3a50f0[_0x8bf13b(0x12b)](_0x1a4db7[_0x8bf13b(0x140)]({'timeNode':_0x391559===_0x8bf13b(0x150)||void 0x0},_0x3812a8[_0x5bd495],_0x24a6a1(_0x92428a),{}));if(_0x391559==='trace'||_0x391559===_0x8bf13b(0x1bb)){let _0x1c7378=Error[_0x8bf13b(0x1be)];try{Error['stackTraceLimit']=0x1/0x0,_0x3a50f0['push'](_0x1a4db7['serialize']({'stackNode':!0x0},new Error()[_0x8bf13b(0x17c)],_0x24a6a1(_0x92428a),{'strLength':0x1/0x0}));}finally{Error[_0x8bf13b(0x1be)]=_0x1c7378;}}return{'method':'log','version':_0x48da5d,'args':[{'ts':_0x10cc53,'session':_0x13add4,'args':_0x3a50f0,'id':_0x4c8a60,'context':_0x34b8b7}]};}catch(_0x50f884){return{'method':_0x8bf13b(0xf9),'version':_0x48da5d,'args':[{'ts':_0x10cc53,'session':_0x13add4,'args':[{'type':_0x8bf13b(0x17d),'error':_0x50f884&&_0x50f884[_0x8bf13b(0x1b0)]}],'id':_0x4c8a60,'context':_0x34b8b7}]};}finally{try{if(_0x340869&&_0x362f9a){let _0x1e55bb=_0x27a290();_0x340869[_0x8bf13b(0x178)]++,_0x340869[_0x8bf13b(0x150)]+=_0x56adc0(_0x362f9a,_0x1e55bb),_0x340869['ts']=_0x1e55bb,_0x2adc0c[_0x8bf13b(0x199)][_0x8bf13b(0x178)]++,_0x2adc0c[_0x8bf13b(0x199)][_0x8bf13b(0x150)]+=_0x56adc0(_0x362f9a,_0x1e55bb),_0x2adc0c[_0x8bf13b(0x199)]['ts']=_0x1e55bb,(_0x340869[_0x8bf13b(0x178)]>_0x184542[_0x8bf13b(0x160)][_0x8bf13b(0x172)]||_0x340869[_0x8bf13b(0x150)]>_0x184542[_0x8bf13b(0x160)][_0x8bf13b(0xe9)])&&(_0x340869[_0x8bf13b(0x1a0)]=!0x0),(_0x2adc0c[_0x8bf13b(0x199)][_0x8bf13b(0x178)]>_0x184542[_0x8bf13b(0xcc)][_0x8bf13b(0x172)]||_0x2adc0c[_0x8bf13b(0x199)][_0x8bf13b(0x150)]>_0x184542['global'][_0x8bf13b(0xe9)])&&(_0x2adc0c[_0x8bf13b(0x199)]['reduceLimits']=!0x0);}}catch{}}}return _0x41cd13;}function G(_0x608e03){var _0x301f67=_0x3bccce;if(_0x608e03&&typeof _0x608e03=='object'&&_0x608e03[_0x301f67(0x101)])switch(_0x608e03[_0x301f67(0x101)][_0x301f67(0xef)]){case _0x301f67(0x14a):return _0x608e03[_0x301f67(0x1a9)](Symbol[_0x301f67(0x1c1)])?Promise['resolve']():_0x608e03;case _0x301f67(0xe3):return Promise[_0x301f67(0xda)]();}return _0x608e03;}((_0x482a1c,_0x1f56df,_0x381e75,_0x5223ca,_0x4c2047,_0x25c77c,_0x5d01c1,_0xc877f3,_0x3cd5c3,_0x37cab3,_0x4c8a1b,_0x5ed381)=>{var _0x3b6697=_0x3bccce;if(_0x482a1c['_console_ninja'])return _0x482a1c[_0x3b6697(0xfb)];let _0x351a4c={'consoleLog':()=>{},'consoleTrace':()=>{},'consoleTime':()=>{},'consoleTimeEnd':()=>{},'autoLog':()=>{},'autoLogMany':()=>{},'autoTraceMany':()=>{},'coverage':()=>{},'autoTrace':()=>{},'autoTime':()=>{},'autoTimeEnd':()=>{}};if(!X(_0x482a1c,_0xc877f3,_0x4c2047))return _0x482a1c[_0x3b6697(0xfb)]=_0x351a4c,_0x482a1c[_0x3b6697(0xfb)];let _0x5788b3=b(_0x482a1c),_0x30e432=_0x5788b3[_0x3b6697(0x13b)],_0x1e618e=_0x5788b3[_0x3b6697(0xe6)],_0x371766=_0x5788b3['now'],_0x37c13f={'hits':{},'ts':{}},_0x293551=J(_0x482a1c,_0x3cd5c3,_0x37c13f,_0x25c77c,_0x5ed381,_0x4c2047===_0x3b6697(0x1b8)?G:void 0x0),_0x4882d1=(_0x15b63f,_0x323d18,_0x3f5e52,_0x599fe2,_0x52c4b8,_0x26b20b)=>{var _0x3bd643=_0x3b6697;let _0x25dfaf=_0x482a1c[_0x3bd643(0xfb)];try{return _0x482a1c[_0x3bd643(0xfb)]=_0x351a4c,_0x293551(_0x15b63f,_0x323d18,_0x3f5e52,_0x599fe2,_0x52c4b8,_0x26b20b);}finally{_0x482a1c[_0x3bd643(0xfb)]=_0x25dfaf;}},_0x317870=_0x84c9b1=>{_0x37c13f['ts'][_0x84c9b1]=_0x1e618e();},_0x34d8c2=(_0x3fc2b3,_0x333dc0)=>{let _0x37c098=_0x37c13f['ts'][_0x333dc0];if(delete _0x37c13f['ts'][_0x333dc0],_0x37c098){let _0x3cbf03=_0x30e432(_0x37c098,_0x1e618e());_0x237f05(_0x4882d1('time',_0x3fc2b3,_0x371766(),_0x5361c8,[_0x3cbf03],_0x333dc0));}},_0x4bfac0=_0x31aa10=>{var _0x392fda=_0x3b6697,_0x139dbd;return _0x4c2047===_0x392fda(0x1b8)&&_0x482a1c[_0x392fda(0x114)]&&((_0x139dbd=_0x31aa10==null?void 0x0:_0x31aa10[_0x392fda(0x186)])==null?void 0x0:_0x139dbd[_0x392fda(0x15e)])&&(_0x31aa10[_0x392fda(0x186)][0x0]['origin']=_0x482a1c[_0x392fda(0x114)]),_0x31aa10;};_0x482a1c[_0x3b6697(0xfb)]={'consoleLog':(_0x2c9f43,_0x32505d)=>{var _0x5c63b2=_0x3b6697;_0x482a1c[_0x5c63b2(0xd2)][_0x5c63b2(0xf9)][_0x5c63b2(0xef)]!==_0x5c63b2(0x198)&&_0x237f05(_0x4882d1(_0x5c63b2(0xf9),_0x2c9f43,_0x371766(),_0x5361c8,_0x32505d));},'consoleTrace':(_0x255c8e,_0x11d324)=>{var _0x814db3=_0x3b6697,_0x1152b0,_0x1733a2;_0x482a1c[_0x814db3(0xd2)][_0x814db3(0xf9)][_0x814db3(0xef)]!==_0x814db3(0x135)&&((_0x1733a2=(_0x1152b0=_0x482a1c[_0x814db3(0x161)])==null?void 0x0:_0x1152b0[_0x814db3(0x109)])!=null&&_0x1733a2[_0x814db3(0xf0)]&&(_0x482a1c[_0x814db3(0x15c)]=!0x0),_0x237f05(_0x4bfac0(_0x4882d1('trace',_0x255c8e,_0x371766(),_0x5361c8,_0x11d324))));},'consoleError':(_0x31b51e,_0x4681db)=>{var _0xab43c0=_0x3b6697;_0x482a1c[_0xab43c0(0x15c)]=!0x0,_0x237f05(_0x4bfac0(_0x4882d1(_0xab43c0(0x1bb),_0x31b51e,_0x371766(),_0x5361c8,_0x4681db)));},'consoleTime':_0x12f1f2=>{_0x317870(_0x12f1f2);},'consoleTimeEnd':(_0x24fc5b,_0x3502f6)=>{_0x34d8c2(_0x3502f6,_0x24fc5b);},'autoLog':(_0x3ba61f,_0x428a41)=>{_0x237f05(_0x4882d1('log',_0x428a41,_0x371766(),_0x5361c8,[_0x3ba61f]));},'autoLogMany':(_0x158141,_0x35bce6)=>{var _0x1a82c3=_0x3b6697;_0x237f05(_0x4882d1(_0x1a82c3(0xf9),_0x158141,_0x371766(),_0x5361c8,_0x35bce6));},'autoTrace':(_0x29d1a9,_0x7b7474)=>{var _0x502e85=_0x3b6697;_0x237f05(_0x4bfac0(_0x4882d1(_0x502e85(0x10c),_0x7b7474,_0x371766(),_0x5361c8,[_0x29d1a9])));},'autoTraceMany':(_0x402454,_0x2083c4)=>{var _0x19bf0f=_0x3b6697;_0x237f05(_0x4bfac0(_0x4882d1(_0x19bf0f(0x10c),_0x402454,_0x371766(),_0x5361c8,_0x2083c4)));},'autoTime':(_0x36dd1d,_0x4c058c,_0x1804b2)=>{_0x317870(_0x1804b2);},'autoTimeEnd':(_0x3ef5fa,_0x409b0c,_0x4355c5)=>{_0x34d8c2(_0x409b0c,_0x4355c5);},'coverage':_0x4f70d6=>{var _0x1407e0=_0x3b6697;_0x237f05({'method':_0x1407e0(0xc0),'version':_0x25c77c,'args':[{'id':_0x4f70d6}]});}};let _0x237f05=H(_0x482a1c,_0x1f56df,_0x381e75,_0x5223ca,_0x4c2047,_0x37cab3,_0x4c8a1b),_0x5361c8=_0x482a1c['_console_ninja_session'];return _0x482a1c[_0x3b6697(0xfb)];})(globalThis,_0x3bccce(0xbf),_0x3bccce(0x118),_0x3bccce(0x14d),_0x3bccce(0x166),_0x3bccce(0x143),'1780389812593',_0x3bccce(0x11f),_0x3bccce(0xfc),'','1',_0x3bccce(0x1b3));");}catch(e){console.error(e);}};/* istanbul ignore next */function oo_oo(/**@type{any}**/i,/**@type{any}**/...v){try{oo_cm().consoleLog(i, v);}catch(e){} return v};/* istanbul ignore next */function oo_tr(/**@type{any}**/i,/**@type{any}**/...v){try{oo_cm().consoleTrace(i, v);}catch(e){} return v};/* istanbul ignore next */function oo_tx(/**@type{any}**/i,/**@type{any}**/...v){try{oo_cm().consoleError(i, v);}catch(e){} return v};/* istanbul ignore next */function oo_ts(/**@type{any}**/v){try{oo_cm().consoleTime(v);}catch(e){} return v;};/* istanbul ignore next */function oo_te(/**@type{any}**/v, /**@type{any}**/i){try{oo_cm().consoleTimeEnd(v, i);}catch(e){} return v;};/*eslint unicorn/no-abusive-eslint-disable:,eslint-comments/disable-enable-pair:,eslint-comments/no-unlimited-disable:,eslint-comments/no-aggregating-enable:,eslint-comments/no-duplicate-disable:,eslint-comments/no-unused-disable:,eslint-comments/no-unused-enable:,*/</script>

<style lang="scss">
.messages_cotroller {
  // border: 1px solid var(--mainText);
  background: var(--main);
  color: white;
  padding: 0.7rem 1rem;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
  // padding: 5px 8px;
  span {
    font-size: 14px;
  }
  &.receiver {
    background: var(--main);
  }
  &.sender {
    background: var(--mainColor-2);
  }
}
.v-autocomplete.v-input > .v-input__control > .v-input__slot {
  margin: 0 !important;

  padding-top: 10px;
}
.user_type_filter {
  border: 1px solid var(--mainColor-2);
  border-radius: 5px;
  // margin-bottom: 10px;
  .multiselect {
    .multiselect__single {
      padding: 0.3rem 1rem !important;
    }
    .multiselect__select:before {
      top: 75% !important;
    }
  }
}
.chat_app {
  .message_status {
    background: linear-gradient(to right, var(--mainColor-2), #773d72af);
    border-radius: 5px;
    font-size: 0.9rem;
    padding: 0.2rem 1rem;
    color: white;
    button {
      transition: all 0.3s;
    }
    button.active {
      color: rgb(191, 255, 0);
      font-weight: bold;
      font-size: 1rem;
    }
  }
}
</style>

<style lang="scss" scoped>
.search-input-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  margin: 0 0.7rem;
}

.friends_header .search-input-wrapper input {
  margin: 0 !important;
  width: 100%;
}

.search-type-selector {
  display: flex;
  justify-content: center;
  gap: 6px;
}

.search-type-btn {
  padding: 2px 12px;
  font-size: 11px;
  border-radius: 12px;
  border: 1px solid var(--mainColor-4);
  background: white;
  color: var(--mainColor-1);
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  outline: none;
  font-weight: 500;
  
  &:hover {
    background: #f7f7f7;
  }
  
  &.active {
    background: var(--mainColor-2);
    color: white;
    border-color: var(--mainColor-2);
    box-shadow: 0 2px 5px rgba(133, 80, 129, 0.25);
  }
}
</style>
